export let prec_div = [
	[84, 48, 5],
	[86, 49, 5],
	[88, 51, 6],
	[90, 52, 7],
	[92, 54, 8],
	[94, 55, 8],
	[96, 57, 9],
	[98, 59, 10],
	[100, 60, 11],
	[102, 62, 12],
	[104, 63, 12],
	[107, 65, 13],
	[109, 67, 14],
	[111, 68, 15],
	[113, 70, 15],
	[115, 71, 16],
	[117, 73, 17],
	[119, 74, 18],
	[121, 76, 19],
	[123, 78, 19],
	[125, 79, 20],
	[128, 81, 21],
	[130, 82, 22],
	[132, 84, 23],
	[134, 86, 23],
	[136, 87, 24],
	[138, 89, 25],
	[140, 90, 26],
	[142, 92, 26],
	[144, 94, 27],
	[146, 95, 28],
	[149, 97, 29],
	[151, 98, 30],
	[153, 100, 30],
	[155, 101, 31],
	[157, 103, 32],
	[159, 105, 33],
	[161, 106, 34],
	[163, 108, 34],
	[165, 109, 35],
	[167, 111, 36],
	[170, 113, 37],
	[172, 114, 37],
	[174, 116, 38],
	[176, 117, 39],
	[178, 119, 40],
	[180, 121, 41],
	[182, 122, 41],
	[184, 124, 42],
	[186, 125, 43],
	[188, 127, 44],
	[191, 129, 44],
	[191, 130, 47],
	[192, 132, 50],
	[193, 133, 53],
	[194, 135, 55],
	[194, 136, 58],
	[195, 138, 60],
	[196, 139, 63],
	[197, 141, 66],
	[197, 143, 69],
	[198, 144, 71],
	[199, 146, 74],
	[200, 147, 77],
	[200, 149, 79],
	[201, 150, 82],
	[202, 152, 84],
	[203, 154, 87],
	[203, 155, 90],
	[204, 157, 93],
	[205, 158, 95],
	[206, 160, 98],
	[206, 161, 101],
	[207, 163, 103],
	[208, 165, 106],
	[209, 166, 109],
	[209, 168, 111],
	[210, 169, 114],
	[211, 171, 117],
	[212, 172, 119],
	[212, 174, 122],
	[213, 176, 125],
	[214, 177, 127],
	[215, 179, 130],
	[216, 180, 133],
	[216, 182, 135],
	[217, 183, 138],
	[218, 185, 140],
	[219, 187, 143],
	[219, 188, 146],
	[220, 190, 148],
	[221, 191, 151],
	[222, 193, 154],
	[222, 194, 157],
	[223, 196, 159],
	[224, 198, 162],
	[225, 199, 165],
	[225, 201, 167],
	[226, 202, 170],
	[227, 204, 173],
	[228, 205, 175],
	[228, 207, 178],
	[229, 209, 180],
	[230, 210, 183],
	[231, 212, 186],
	[231, 213, 189],
	[232, 215, 191],
	[233, 216, 194],
	[234, 218, 197],
	[234, 219, 199],
	[235, 221, 202],
	[236, 223, 205],
	[237, 224, 207],
	[238, 226, 210],
	[238, 227, 212],
	[239, 229, 215],
	[240, 230, 218],
	[241, 232, 221],
	[241, 234, 223],
	[242, 235, 226],
	[243, 237, 229],
	[244, 238, 231],
	[244, 240, 234],
	[245, 241, 236],
	[246, 243, 239],
	[247, 245, 242],
	[247, 246, 244],
	[248, 248, 247],
	[247, 248, 248],
	[245, 247, 246],
	[242, 245, 245],
	[240, 244, 244],
	[237, 243, 242],
	[234, 241, 241],
	[232, 240, 239],
	[229, 239, 238],
	[227, 238, 237],
	[224, 236, 235],
	[222, 235, 234],
	[219, 234, 233],
	[216, 232, 231],
	[214, 231, 230],
	[211, 230, 228],
	[209, 229, 227],
	[206, 227, 226],
	[204, 226, 224],
	[201, 225, 223],
	[199, 224, 221],
	[196, 222, 220],
	[193, 221, 219],
	[191, 220, 217],
	[188, 218, 216],
	[186, 217, 215],
	[183, 216, 213],
	[181, 215, 212],
	[178, 213, 210],
	[175, 212, 209],
	[173, 211, 208],
	[170, 209, 206],
	[168, 208, 205],
	[165, 207, 203],
	[163, 206, 202],
	[160, 204, 201],
	[158, 203, 199],
	[155, 202, 198],
	[152, 200, 197],
	[150, 199, 195],
	[147, 198, 194],
	[145, 197, 192],
	[142, 195, 191],
	[140, 194, 190],
	[137, 193, 188],
	[134, 191, 187],
	[132, 190, 185],
	[129, 189, 184],
	[127, 188, 183],
	[124, 186, 181],
	[122, 185, 180],
	[119, 184, 179],
	[117, 183, 177],
	[114, 181, 176],
	[111, 180, 174],
	[109, 179, 173],
	[106, 177, 172],
	[104, 176, 170],
	[101, 175, 169],
	[99, 174, 167],
	[96, 172, 166],
	[93, 171, 165],
	[91, 170, 163],
	[88, 168, 162],
	[86, 167, 161],
	[83, 166, 159],
	[81, 165, 158],
	[78, 163, 156],
	[76, 162, 155],
	[73, 161, 154],
	[70, 159, 152],
	[68, 158, 151],
	[65, 157, 149],
	[63, 156, 148],
	[60, 154, 147],
	[58, 153, 145],
	[55, 152, 144],
	[53, 151, 143],
	[51, 149, 141],
	[50, 147, 139],
	[49, 145, 137],
	[48, 143, 135],
	[47, 142, 133],
	[46, 140, 131],
	[45, 138, 129],
	[44, 136, 128],
	[43, 134, 126],
	[42, 133, 124],
	[41, 131, 122],
	[40, 129, 120],
	[39, 127, 118],
	[38, 126, 116],
	[37, 124, 115],
	[36, 122, 113],
	[35, 120, 111],
	[34, 118, 109],
	[33, 117, 107],
	[32, 115, 105],
	[31, 113, 103],
	[30, 111, 102],
	[29, 109, 100],
	[28, 108, 98],
	[27, 106, 96],
	[25, 104, 94],
	[24, 102, 92],
	[23, 101, 90],
	[22, 99, 88],
	[21, 97, 87],
	[20, 95, 85],
	[19, 93, 83],
	[18, 92, 81],
	[17, 90, 79],
	[16, 88, 77],
	[15, 86, 75],
	[14, 84, 74],
	[13, 83, 72],
	[12, 81, 70],
	[11, 79, 68],
	[10, 77, 66],
	[9, 76, 64],
	[8, 74, 62],
	[7, 72, 61],
	[6, 70, 59],
	[5, 68, 57],
	[4, 67, 55],
	[3, 65, 53],
	[2, 63, 51],
	[1, 61, 49],
	[0, 60, 48]
];

export let chem_div = [
	[0, 68, 57],
	[1, 70, 57],
	[3, 72, 58],
	[5, 74, 59],
	[7, 76, 60],
	[8, 78, 60],
	[10, 80, 61],
	[12, 82, 62],
	[14, 84, 63],
	[15, 86, 64],
	[17, 88, 64],
	[19, 90, 65],
	[21, 92, 66],
	[22, 95, 67],
	[24, 97, 67],
	[26, 99, 68],
	[28, 101, 69],
	[30, 103, 70],
	[31, 105, 71],
	[33, 107, 71],
	[35, 109, 72],
	[37, 111, 73],
	[38, 113, 74],
	[40, 115, 75],
	[42, 117, 75],
	[44, 119, 76],
	[45, 122, 77],
	[47, 124, 78],
	[49, 126, 78],
	[51, 128, 79],
	[52, 130, 80],
	[54, 132, 81],
	[56, 134, 82],
	[58, 136, 82],
	[60, 138, 83],
	[61, 140, 84],
	[63, 142, 85],
	[65, 144, 86],
	[67, 146, 86],
	[68, 149, 87],
	[70, 151, 88],
	[72, 153, 89],
	[74, 155, 89],
	[75, 157, 90],
	[77, 159, 91],
	[79, 161, 92],
	[81, 163, 93],
	[82, 165, 93],
	[84, 167, 94],
	[86, 169, 95],
	[88, 171, 96],
	[90, 174, 97],
	[92, 174, 98],
	[94, 175, 100],
	[96, 176, 102],
	[98, 177, 104],
	[100, 178, 106],
	[102, 179, 108],
	[104, 180, 110],
	[106, 181, 112],
	[108, 182, 114],
	[110, 183, 116],
	[112, 184, 118],
	[114, 185, 120],
	[117, 186, 122],
	[119, 187, 124],
	[121, 188, 126],
	[123, 189, 128],
	[125, 190, 130],
	[127, 191, 132],
	[129, 192, 134],
	[131, 193, 136],
	[133, 194, 138],
	[135, 195, 140],
	[137, 196, 142],
	[139, 197, 144],
	[141, 198, 146],
	[144, 199, 148],
	[146, 200, 150],
	[148, 201, 152],
	[150, 202, 154],
	[152, 203, 156],
	[154, 204, 158],
	[156, 205, 160],
	[158, 206, 162],
	[160, 207, 164],
	[162, 208, 166],
	[164, 209, 168],
	[166, 210, 170],
	[168, 211, 172],
	[171, 212, 174],
	[173, 213, 176],
	[175, 214, 178],
	[177, 215, 180],
	[179, 216, 182],
	[181, 217, 184],
	[183, 218, 186],
	[185, 219, 188],
	[187, 220, 190],
	[189, 221, 192],
	[191, 222, 194],
	[193, 223, 196],
	[195, 224, 198],
	[198, 224, 200],
	[200, 225, 202],
	[202, 226, 204],
	[204, 227, 206],
	[206, 228, 208],
	[208, 229, 210],
	[210, 230, 212],
	[212, 231, 214],
	[214, 232, 216],
	[216, 233, 218],
	[218, 234, 220],
	[220, 235, 222],
	[223, 236, 224],
	[225, 237, 226],
	[227, 238, 228],
	[229, 239, 230],
	[231, 240, 232],
	[233, 241, 234],
	[235, 242, 236],
	[237, 243, 238],
	[239, 244, 240],
	[241, 245, 242],
	[243, 246, 244],
	[245, 247, 246],
	[247, 248, 248],
	[248, 248, 248],
	[247, 246, 247],
	[245, 244, 246],
	[244, 242, 245],
	[243, 240, 244],
	[242, 239, 243],
	[240, 237, 242],
	[239, 235, 241],
	[238, 233, 240],
	[237, 231, 239],
	[235, 230, 238],
	[234, 228, 237],
	[233, 226, 236],
	[232, 224, 235],
	[230, 223, 234],
	[229, 221, 233],
	[228, 219, 232],
	[227, 217, 231],
	[225, 215, 230],
	[224, 214, 229],
	[223, 212, 228],
	[222, 210, 227],
	[220, 208, 226],
	[219, 206, 225],
	[218, 205, 224],
	[217, 203, 223],
	[215, 201, 221],
	[214, 199, 220],
	[213, 197, 219],
	[211, 196, 218],
	[210, 194, 217],
	[209, 192, 216],
	[208, 190, 215],
	[206, 189, 214],
	[205, 187, 213],
	[204, 185, 212],
	[203, 183, 211],
	[201, 181, 210],
	[200, 180, 209],
	[199, 178, 208],
	[198, 176, 207],
	[196, 174, 206],
	[195, 172, 205],
	[194, 171, 204],
	[193, 169, 203],
	[191, 167, 202],
	[190, 165, 201],
	[189, 163, 200],
	[188, 162, 199],
	[186, 160, 198],
	[185, 158, 197],
	[184, 156, 196],
	[183, 154, 195],
	[181, 153, 194],
	[180, 151, 193],
	[179, 149, 192],
	[178, 147, 191],
	[176, 146, 190],
	[175, 144, 189],
	[174, 142, 188],
	[173, 140, 187],
	[171, 138, 186],
	[170, 137, 185],
	[169, 135, 184],
	[168, 133, 183],
	[166, 131, 182],
	[165, 129, 181],
	[164, 128, 180],
	[163, 126, 179],
	[161, 124, 178],
	[160, 122, 177],
	[159, 120, 176],
	[158, 119, 175],
	[156, 117, 174],
	[155, 115, 173],
	[154, 113, 172],
	[153, 112, 171],
	[151, 109, 169],
	[149, 107, 167],
	[147, 105, 165],
	[146, 103, 163],
	[144, 101, 161],
	[142, 98, 159],
	[140, 96, 157],
	[139, 94, 155],
	[137, 92, 154],
	[135, 90, 152],
	[133, 87, 150],
	[132, 85, 148],
	[130, 83, 146],
	[128, 81, 144],
	[126, 79, 142],
	[125, 76, 140],
	[123, 74, 139],
	[121, 72, 137],
	[119, 70, 135],
	[118, 68, 133],
	[116, 65, 131],
	[114, 63, 129],
	[112, 61, 127],
	[111, 59, 125],
	[109, 57, 123],
	[107, 54, 122],
	[105, 52, 120],
	[104, 50, 118],
	[102, 48, 116],
	[100, 46, 114],
	[98, 43, 112],
	[97, 41, 110],
	[95, 39, 108],
	[93, 37, 107],
	[91, 35, 105],
	[90, 32, 103],
	[88, 30, 101],
	[86, 28, 99],
	[84, 26, 97],
	[83, 24, 95],
	[81, 21, 93],
	[79, 19, 91],
	[77, 17, 90],
	[76, 15, 88],
	[74, 13, 86],
	[72, 10, 84],
	[70, 8, 82],
	[69, 6, 80],
	[67, 4, 78],
	[65, 2, 76],
	[64, 0, 75]
];

export let cryo_div = [
	[38, 38, 0],
	[39, 39, 2],
	[41, 41, 3],
	[42, 42, 5],
	[44, 44, 6],
	[45, 46, 8],
	[47, 47, 9],
	[48, 49, 11],
	[50, 50, 12],
	[52, 52, 13],
	[53, 54, 14],
	[55, 55, 16],
	[57, 57, 17],
	[58, 58, 18],
	[60, 60, 19],
	[62, 62, 20],
	[63, 64, 22],
	[65, 65, 23],
	[67, 67, 24],
	[69, 69, 26],
	[70, 70, 27],
	[72, 72, 29],
	[74, 74, 30],
	[76, 76, 31],
	[78, 78, 33],
	[79, 79, 34],
	[81, 81, 36],
	[83, 83, 37],
	[85, 85, 39],
	[87, 87, 40],
	[89, 89, 42],
	[90, 90, 43],
	[92, 92, 45],
	[94, 94, 46],
	[96, 96, 48],
	[98, 98, 50],
	[100, 100, 51],
	[102, 102, 53],
	[104, 104, 54],
	[105, 105, 56],
	[107, 107, 57],
	[109, 109, 59],
	[111, 111, 61],
	[113, 113, 62],
	[115, 115, 64],
	[117, 117, 65],
	[119, 119, 67],
	[121, 121, 69],
	[123, 123, 70],
	[125, 125, 72],
	[127, 127, 74],
	[129, 129, 75],
	[131, 131, 77],
	[133, 133, 79],
	[135, 135, 80],
	[137, 137, 82],
	[139, 139, 84],
	[141, 141, 85],
	[143, 143, 87],
	[145, 145, 89],
	[147, 147, 90],
	[149, 149, 92],
	[151, 151, 94],
	[153, 153, 95],
	[155, 155, 97],
	[157, 157, 99],
	[159, 159, 101],
	[161, 161, 103],
	[163, 163, 105],
	[165, 165, 106],
	[167, 167, 108],
	[169, 169, 110],
	[171, 171, 112],
	[173, 173, 114],
	[175, 175, 117],
	[177, 177, 119],
	[179, 179, 121],
	[181, 181, 123],
	[183, 183, 125],
	[185, 185, 128],
	[187, 187, 130],
	[189, 189, 133],
	[191, 191, 135],
	[193, 193, 137],
	[195, 194, 140],
	[196, 196, 142],
	[198, 198, 145],
	[199, 199, 147],
	[201, 201, 150],
	[202, 202, 152],
	[204, 204, 155],
	[205, 205, 157],
	[207, 206, 159],
	[208, 208, 162],
	[209, 209, 164],
	[210, 210, 167],
	[212, 212, 169],
	[213, 213, 171],
	[214, 214, 174],
	[215, 215, 176],
	[217, 216, 179],
	[218, 218, 181],
	[219, 219, 183],
	[220, 220, 186],
	[221, 221, 188],
	[223, 222, 190],
	[224, 224, 193],
	[225, 225, 195],
	[226, 226, 198],
	[227, 227, 200],
	[228, 228, 202],
	[229, 229, 205],
	[231, 230, 207],
	[232, 232, 209],
	[233, 233, 212],
	[234, 234, 214],
	[234, 235, 216],
	[235, 235, 218],
	[236, 236, 221],
	[236, 237, 223],
	[237, 238, 225],
	[237, 238, 227],
	[237, 239, 228],
	[237, 239, 230],
	[237, 239, 232],
	[237, 239, 233],
	[236, 238, 234],
	[235, 238, 235],
	[234, 237, 236],
	[232, 237, 236],
	[231, 236, 236],
	[229, 234, 237],
	[227, 233, 236],
	[225, 232, 236],
	[223, 230, 236],
	[221, 229, 235],
	[219, 227, 234],
	[217, 226, 233],
	[214, 224, 233],
	[212, 222, 232],
	[210, 220, 231],
	[207, 219, 229],
	[205, 217, 228],
	[203, 215, 227],
	[200, 213, 226],
	[198, 212, 225],
	[195, 210, 223],
	[193, 208, 222],
	[191, 206, 221],
	[188, 204, 220],
	[186, 202, 218],
	[183, 201, 217],
	[181, 199, 216],
	[179, 197, 215],
	[176, 195, 213],
	[174, 193, 212],
	[171, 192, 211],
	[169, 190, 210],
	[167, 188, 208],
	[164, 186, 207],
	[162, 184, 206],
	[160, 183, 205],
	[157, 181, 203],
	[155, 179, 202],
	[152, 177, 201],
	[150, 175, 200],
	[148, 174, 199],
	[145, 172, 197],
	[143, 170, 196],
	[141, 168, 195],
	[138, 166, 194],
	[136, 165, 192],
	[134, 163, 191],
	[131, 161, 190],
	[129, 159, 189],
	[127, 158, 187],
	[124, 156, 186],
	[122, 154, 185],
	[120, 152, 184],
	[117, 150, 183],
	[115, 149, 181],
	[113, 147, 180],
	[111, 145, 179],
	[108, 143, 178],
	[106, 142, 177],
	[104, 140, 175],
	[101, 138, 174],
	[99, 136, 173],
	[97, 135, 172],
	[95, 133, 170],
	[92, 131, 169],
	[90, 130, 168],
	[88, 128, 167],
	[86, 126, 166],
	[84, 124, 164],
	[81, 123, 163],
	[79, 121, 162],
	[77, 119, 161],
	[75, 117, 160],
	[73, 116, 158],
	[71, 114, 157],
	[68, 112, 156],
	[66, 110, 155],
	[64, 109, 153],
	[62, 107, 152],
	[60, 105, 151],
	[58, 104, 150],
	[57, 102, 148],
	[55, 100, 147],
	[53, 98, 146],
	[52, 97, 144],
	[50, 95, 143],
	[49, 93, 141],
	[47, 91, 140],
	[46, 90, 138],
	[45, 88, 137],
	[44, 86, 135],
	[43, 84, 134],
	[42, 83, 132],
	[42, 81, 131],
	[41, 79, 129],
	[41, 78, 128],
	[40, 76, 126],
	[40, 74, 125],
	[40, 73, 123],
	[40, 71, 122],
	[40, 69, 120],
	[40, 68, 118],
	[40, 66, 117],
	[40, 64, 115],
	[40, 63, 114],
	[40, 61, 112],
	[40, 60, 111],
	[40, 58, 109],
	[40, 57, 107],
	[41, 55, 106],
	[41, 54, 104],
	[41, 52, 103],
	[41, 50, 101],
	[41, 49, 100],
	[41, 47, 98],
	[42, 46, 97],
	[42, 44, 95],
	[42, 43, 94],
	[42, 42, 92],
	[42, 40, 91],
	[42, 39, 89],
	[42, 37, 88],
	[43, 36, 86],
	[43, 34, 85],
	[43, 33, 83],
	[43, 31, 82],
	[43, 30, 80],
	[43, 28, 79],
	[43, 27, 77],
	[43, 25, 76]
];

export let misc_div_custom = [
	[8, 29, 88],
	[9, 30, 91],
	[11, 31, 95],
	[13, 33, 99],
	[15, 34, 103],
	[17, 36, 106],
	[18, 37, 110],
	[20, 39, 114],
	[22, 40, 118],
	[24, 42, 121],
	[26, 43, 125],
	[28, 44, 129],
	[29, 46, 133],
	[31, 47, 137],
	[33, 49, 140],
	[35, 50, 144],
	[36, 52, 148],
	[36, 54, 149],
	[36, 57, 150],
	[36, 60, 151],
	[36, 62, 153],
	[36, 65, 154],
	[35, 68, 155],
	[35, 70, 156],
	[35, 73, 158],
	[35, 76, 159],
	[35, 78, 160],
	[34, 81, 161],
	[34, 83, 163],
	[34, 86, 164],
	[34, 89, 165],
	[34, 91, 166],
	[33, 94, 168],
	[33, 97, 169],
	[33, 101, 171],
	[32, 104, 172],
	[32, 107, 174],
	[32, 110, 175],
	[32, 113, 177],
	[31, 117, 178],
	[31, 120, 180],
	[31, 123, 181],
	[30, 126, 183],
	[30, 129, 184],
	[30, 133, 186],
	[29, 136, 187],
	[29, 139, 189],
	[29, 142, 190],
	[29, 145, 192],
	[31, 147, 192],
	[34, 150, 192],
	[36, 152, 192],
	[38, 154, 193],
	[40, 157, 193],
	[43, 159, 193],
	[45, 161, 193],
	[47, 164, 194],
	[50, 166, 194],
	[52, 168, 194],
	[54, 171, 194],
	[56, 173, 195],
	[59, 175, 195],
	[61, 178, 195],
	[63, 180, 195],
	[66, 182, 195],
	[70, 183, 195],
	[74, 185, 194],
	[78, 186, 194],
	[82, 188, 193],
	[85, 189, 192],
	[89, 191, 192],
	[93, 192, 191],
	[97, 194, 191],
	[101, 195, 190],
	[105, 197, 190],
	[109, 198, 189],
	[113, 199, 188],
	[117, 201, 188],
	[121, 202, 187],
	[124, 204, 187],
	[129, 205, 186],
	[133, 207, 186],
	[138, 209, 185],
	[142, 211, 185],
	[147, 212, 185],
	[151, 214, 184],
	[156, 216, 184],
	[160, 218, 183],
	[165, 219, 183],
	[169, 221, 182],
	[174, 223, 182],
	[178, 225, 181],
	[183, 226, 181],
	[187, 228, 181],
	[192, 230, 180],
	[197, 232, 180],
	[200, 233, 179],
	[202, 234, 179],
	[205, 235, 179],
	[207, 236, 179],
	[209, 237, 179],
	[212, 238, 178],
	[214, 239, 178],
	[217, 240, 178],
	[219, 241, 178],
	[221, 242, 178],
	[224, 242, 178],
	[226, 243, 177], //
	[227, 244, 179],
	[227, 245, 182],
	[228, 246, 184],
	[229, 247, 186],
	[230, 249, 189],
	[230, 250, 191],
	[231, 251, 193],
	[232, 252, 195],
	[232, 253, 198],
	[233, 254, 200], //
	[235, 254, 206],
	[237, 254, 211],
	[240, 254, 217],
	[242, 254, 222],
	[244, 255, 228],
	[246, 255, 233],
	[248, 255, 239],
	[251, 255, 244],
	[253, 255, 250],
	[255, 255, 255], //
	[255, 254, 247],
	[255, 253, 240],
	[255, 252, 232],
	[255, 251, 224],
	[255, 250, 217],
	[255, 248, 209],
	[255, 247, 201],
	[255, 246, 193],
	[255, 245, 186],
	[255, 244, 178], //
	[255, 243, 175],
	[255, 242, 172],
	[255, 241, 170],
	[255, 240, 167],
	[255, 238, 164],
	[255, 237, 161],
	[254, 236, 159],
	[254, 235, 156],
	[254, 234, 153],
	[254, 232, 151],
	[254, 231, 148],
	[254, 230, 145],
	[254, 229, 143],
	[254, 227, 140],
	[254, 226, 137],
	[254, 225, 135],
	[254, 223, 132],
	[254, 222, 130],
	[254, 221, 127],
	[254, 220, 124],
	[254, 218, 122],
	[254, 217, 119],
	[254, 215, 116],
	[254, 213, 114],
	[254, 211, 111],
	[254, 208, 108],
	[254, 206, 106],
	[254, 203, 103],
	[254, 201, 101],
	[254, 198, 98],
	[254, 196, 95],
	[254, 193, 93],
	[254, 191, 90],
	[254, 188, 87],
	[254, 186, 85],
	[254, 184, 82],
	[254, 181, 79],
	[254, 179, 77],
	[253, 176, 75],
	[253, 174, 74],
	[253, 172, 73],
	[253, 169, 72],
	[253, 167, 71],
	[253, 165, 70],
	[253, 162, 69],
	[253, 160, 68],
	[253, 158, 67],
	[253, 155, 66],
	[253, 153, 65],
	[253, 151, 64],
	[253, 148, 63],
	[253, 146, 62],
	[253, 144, 61],
	[253, 141, 60],
	[252, 138, 59],
	[252, 134, 58],
	[252, 130, 57],
	[252, 126, 55],
	[252, 122, 54],
	[252, 118, 53],
	[252, 114, 52],
	[252, 110, 51],
	[252, 106, 50],
	[252, 102, 49],
	[252, 98, 47],
	[252, 94, 46],
	[252, 90, 45],
	[252, 87, 44],
	[252, 83, 43],
	[252, 79, 42],
	[250, 75, 41],
	[249, 72, 40],
	[247, 69, 39],
	[246, 65, 38],
	[244, 62, 37],
	[243, 59, 36],
	[241, 56, 36],
	[239, 52, 35],
	[238, 49, 34],
	[236, 46, 33],
	[235, 42, 32],
	[233, 39, 31],
	[232, 36, 30],
	[230, 33, 29],
	[228, 29, 29],
	[227, 26, 28],
	[225, 24, 28],
	[222, 23, 29],
	[220, 21, 29],
	[217, 19, 30],
	[215, 18, 31],
	[213, 16, 31],
	[210, 14, 32],
	[208, 13, 32],
	[205, 11, 33],
	[203, 9, 34],
	[201, 8, 34],
	[198, 6, 35],
	[196, 5, 36],
	[194, 3, 36],
	[191, 1, 37],
	[189, 0, 37],
	[185, 0, 38],
	[181, 0, 38],
	[177, 0, 38],
	[174, 0, 38],
	[170, 0, 38],
	[166, 0, 38],
	[162, 0, 38],
	[158, 0, 38],
	[154, 0, 38],
	[151, 0, 38],
	[147, 0, 38],
	[143, 0, 38],
	[139, 0, 38],
	[135, 0, 38],
	[131, 0, 38],
	[128, 0, 38]
];
export let misc_div = [
	[8, 29, 88],
	[9, 30, 91],
	[11, 31, 95],
	[13, 33, 99],
	[15, 34, 103],
	[17, 36, 106],
	[18, 37, 110],
	[20, 39, 114],
	[22, 40, 118],
	[24, 42, 121],
	[26, 43, 125],
	[28, 44, 129],
	[29, 46, 133],
	[31, 47, 137],
	[33, 49, 140],
	[35, 50, 144],
	[36, 52, 148],
	[36, 54, 149],
	[36, 57, 150],
	[36, 60, 151],
	[36, 62, 153],
	[36, 65, 154],
	[35, 68, 155],
	[35, 70, 156],
	[35, 73, 158],
	[35, 76, 159],
	[35, 78, 160],
	[34, 81, 161],
	[34, 83, 163],
	[34, 86, 164],
	[34, 89, 165],
	[34, 91, 166],
	[33, 94, 168],
	[33, 97, 169],
	[33, 101, 171],
	[32, 104, 172],
	[32, 107, 174],
	[32, 110, 175],
	[32, 113, 177],
	[31, 117, 178],
	[31, 120, 180],
	[31, 123, 181],
	[30, 126, 183],
	[30, 129, 184],
	[30, 133, 186],
	[29, 136, 187],
	[29, 139, 189],
	[29, 142, 190],
	[29, 145, 192],
	[31, 147, 192],
	[34, 150, 192],
	[36, 152, 192],
	[38, 154, 193],
	[40, 157, 193],
	[43, 159, 193],
	[45, 161, 193],
	[47, 164, 194],
	[50, 166, 194],
	[52, 168, 194],
	[54, 171, 194],
	[56, 173, 195],
	[59, 175, 195],
	[61, 178, 195],
	[63, 180, 195],
	[66, 182, 195],
	[70, 183, 195],
	[74, 185, 194],
	[78, 186, 194],
	[82, 188, 193],
	[85, 189, 192],
	[89, 191, 192],
	[93, 192, 191],
	[97, 194, 191],
	[101, 195, 190],
	[105, 197, 190],
	[109, 198, 189],
	[113, 199, 188],
	[117, 201, 188],
	[121, 202, 187],
	[124, 204, 187],
	[129, 205, 186],
	[133, 207, 186],
	[138, 209, 185],
	[142, 211, 185],
	[147, 212, 185],
	[151, 214, 184],
	[156, 216, 184],
	[160, 218, 183],
	[165, 219, 183],
	[169, 221, 182],
	[174, 223, 182],
	[178, 225, 181],
	[183, 226, 181],
	[187, 228, 181],
	[192, 230, 180],
	[197, 232, 180],
	[200, 233, 179],
	[202, 234, 179],
	[205, 235, 179],
	[207, 236, 179],
	[209, 237, 179],
	[212, 238, 178],
	[214, 239, 178],
	[217, 240, 178],
	[219, 241, 178],
	[221, 242, 178],
	[224, 242, 178],
	[226, 243, 177],
	[229, 244, 177],
	[231, 245, 177],
	[233, 246, 177],
	[236, 247, 177],
	[237, 248, 178],
	[238, 248, 181],
	[240, 249, 183],
	[241, 249, 186],
	[242, 250, 188],
	[243, 250, 191],
	[244, 250, 193],
	[245, 251, 196],
	[246, 251, 198],
	[247, 252, 201],
	[249, 252, 203],
	[250, 253, 206],
	[251, 253, 208],
	[252, 254, 211],
	[253, 254, 213],
	[254, 254, 216],
	[255, 254, 203],
	[255, 253, 200],
	[255, 252, 197],
	[255, 251, 195],
	[255, 250, 192],
	[255, 249, 189],
	[255, 247, 186],
	[255, 246, 183],
	[255, 245, 181],
	[255, 244, 178],
	[255, 243, 175],
	[255, 242, 172],
	[255, 241, 170],
	[255, 240, 167],
	[255, 238, 164],
	[255, 237, 161],
	[254, 236, 159],
	[254, 235, 156],
	[254, 234, 153],
	[254, 232, 151],
	[254, 231, 148],
	[254, 230, 145],
	[254, 229, 143],
	[254, 227, 140],
	[254, 226, 137],
	[254, 225, 135],
	[254, 223, 132],
	[254, 222, 130],
	[254, 221, 127],
	[254, 220, 124],
	[254, 218, 122],
	[254, 217, 119],
	[254, 215, 116],
	[254, 213, 114],
	[254, 211, 111],
	[254, 208, 108],
	[254, 206, 106],
	[254, 203, 103],
	[254, 201, 101],
	[254, 198, 98],
	[254, 196, 95],
	[254, 193, 93],
	[254, 191, 90],
	[254, 188, 87],
	[254, 186, 85],
	[254, 184, 82],
	[254, 181, 79],
	[254, 179, 77],
	[253, 176, 75],
	[253, 174, 74],
	[253, 172, 73],
	[253, 169, 72],
	[253, 167, 71],
	[253, 165, 70],
	[253, 162, 69],
	[253, 160, 68],
	[253, 158, 67],
	[253, 155, 66],
	[253, 153, 65],
	[253, 151, 64],
	[253, 148, 63],
	[253, 146, 62],
	[253, 144, 61],
	[253, 141, 60],
	[252, 138, 59],
	[252, 134, 58],
	[252, 130, 57],
	[252, 126, 55],
	[252, 122, 54],
	[252, 118, 53],
	[252, 114, 52],
	[252, 110, 51],
	[252, 106, 50],
	[252, 102, 49],
	[252, 98, 47],
	[252, 94, 46],
	[252, 90, 45],
	[252, 87, 44],
	[252, 83, 43],
	[252, 79, 42],
	[250, 75, 41],
	[249, 72, 40],
	[247, 69, 39],
	[246, 65, 38],
	[244, 62, 37],
	[243, 59, 36],
	[241, 56, 36],
	[239, 52, 35],
	[238, 49, 34],
	[236, 46, 33],
	[235, 42, 32],
	[233, 39, 31],
	[232, 36, 30],
	[230, 33, 29],
	[228, 29, 29],
	[227, 26, 28],
	[225, 24, 28],
	[222, 23, 29],
	[220, 21, 29],
	[217, 19, 30],
	[215, 18, 31],
	[213, 16, 31],
	[210, 14, 32],
	[208, 13, 32],
	[205, 11, 33],
	[203, 9, 34],
	[201, 8, 34],
	[198, 6, 35],
	[196, 5, 36],
	[194, 3, 36],
	[191, 1, 37],
	[189, 0, 37],
	[185, 0, 38],
	[181, 0, 38],
	[177, 0, 38],
	[174, 0, 38],
	[170, 0, 38],
	[166, 0, 38],
	[162, 0, 38],
	[158, 0, 38],
	[154, 0, 38],
	[151, 0, 38],
	[147, 0, 38],
	[143, 0, 38],
	[139, 0, 38],
	[135, 0, 38],
	[131, 0, 38],
	[128, 0, 38]
];

export let slev_div = [
	[2, 71, 104],
	[3, 72, 105],
	[4, 74, 107],
	[6, 76, 109],
	[7, 78, 111],
	[8, 79, 113],
	[10, 81, 115],
	[11, 83, 117],
	[12, 85, 119],
	[14, 86, 121],
	[15, 88, 123],
	[17, 90, 125],
	[18, 92, 127],
	[19, 94, 129],
	[21, 95, 131],
	[22, 97, 133],
	[23, 99, 135],
	[25, 101, 137],
	[26, 102, 139],
	[27, 104, 141],
	[29, 106, 143],
	[30, 108, 145],
	[32, 109, 147],
	[33, 111, 149],
	[34, 113, 151],
	[36, 115, 153],
	[37, 117, 154],
	[38, 118, 156],
	[40, 120, 158],
	[41, 122, 160],
	[42, 124, 162],
	[44, 125, 164],
	[45, 127, 166],
	[47, 129, 168],
	[48, 131, 170],
	[49, 133, 172],
	[51, 134, 174],
	[52, 136, 176],
	[53, 138, 178],
	[55, 140, 180],
	[56, 141, 182],
	[57, 143, 184],
	[59, 145, 186],
	[60, 147, 188],
	[62, 148, 190],
	[63, 150, 192],
	[64, 152, 194],
	[66, 154, 196],
	[67, 156, 198],
	[68, 157, 200],
	[70, 159, 202],
	[71, 161, 204],
	[72, 163, 205],
	[74, 164, 207],
	[75, 166, 209],
	[77, 168, 211],
	[78, 170, 213],
	[79, 172, 215],
	[81, 173, 217],
	[82, 175, 219],
	[83, 177, 221],
	[85, 179, 223],
	[86, 180, 225],
	[87, 182, 227],
	[89, 184, 229],
	[92, 185, 229],
	[94, 186, 229],
	[97, 187, 230],
	[99, 188, 230],
	[102, 189, 230],
	[104, 190, 230],
	[107, 191, 231],
	[109, 192, 231],
	[112, 193, 231],
	[114, 194, 232],
	[117, 195, 232],
	[119, 196, 232],
	[122, 197, 233],
	[124, 198, 233],
	[127, 199, 233],
	[129, 200, 234],
	[132, 201, 234],
	[134, 202, 234],
	[137, 203, 235],
	[139, 204, 235],
	[142, 205, 235],
	[144, 206, 235],
	[147, 207, 236],
	[149, 208, 236],
	[152, 209, 236],
	[154, 210, 237],
	[157, 211, 237],
	[159, 212, 237],
	[162, 213, 238],
	[164, 214, 238],
	[167, 215, 238],
	[169, 216, 239],
	[172, 217, 239],
	[174, 218, 239],
	[177, 219, 240],
	[179, 220, 240],
	[182, 221, 240],
	[185, 223, 241],
	[187, 224, 241],
	[190, 225, 241],
	[192, 226, 241],
	[195, 227, 242],
	[197, 228, 242],
	[200, 229, 242],
	[202, 230, 243],
	[205, 231, 243],
	[207, 232, 243],
	[210, 233, 244],
	[212, 234, 244],
	[215, 235, 244],
	[217, 236, 245],
	[220, 237, 245],
	[222, 238, 245],
	[225, 239, 246],
	[227, 240, 246],
	[230, 241, 246],
	[232, 242, 246],
	[235, 243, 247],
	[237, 244, 247],
	[240, 245, 247],
	[242, 246, 248],
	[245, 247, 248],
	[247, 248, 248],
	[248, 248, 247],
	[248, 246, 244],
	[248, 245, 240],
	[248, 244, 237],
	[248, 242, 234],
	[247, 241, 231],
	[247, 239, 227],
	[247, 238, 224],
	[247, 237, 221],
	[247, 235, 218],
	[246, 234, 214],
	[246, 232, 211],
	[246, 231, 208],
	[246, 229, 205],
	[246, 228, 201],
	[245, 227, 198],
	[245, 225, 195],
	[245, 224, 192],
	[245, 222, 188],
	[245, 221, 185],
	[244, 220, 182],
	[244, 218, 179],
	[244, 217, 175],
	[244, 215, 172],
	[244, 214, 169],
	[243, 212, 166],
	[243, 211, 162],
	[243, 210, 159],
	[243, 208, 156],
	[242, 207, 153],
	[242, 205, 149],
	[242, 204, 146],
	[242, 203, 143],
	[242, 201, 140],
	[241, 200, 136],
	[241, 198, 133],
	[241, 197, 130],
	[241, 196, 127],
	[241, 194, 123],
	[240, 193, 120],
	[240, 191, 117],
	[240, 190, 114],
	[240, 189, 111],
	[240, 187, 107],
	[239, 186, 104],
	[239, 184, 101],
	[239, 183, 98],
	[239, 181, 94],
	[239, 180, 91],
	[238, 179, 88],
	[238, 177, 85],
	[238, 176, 81],
	[238, 174, 78],
	[238, 173, 75],
	[237, 172, 72],
	[237, 170, 68],
	[237, 169, 65],
	[237, 167, 62],
	[237, 166, 59],
	[236, 164, 55],
	[236, 163, 52],
	[236, 162, 49],
	[236, 160, 46],
	[236, 159, 42],
	[234, 157, 41],
	[231, 156, 41],
	[229, 154, 41],
	[226, 152, 41],
	[224, 151, 41],
	[221, 149, 41],
	[219, 148, 41],
	[217, 146, 40],
	[214, 144, 40],
	[212, 143, 40],
	[209, 141, 40],
	[207, 140, 40],
	[204, 138, 40],
	[202, 136, 40],
	[199, 135, 39],
	[197, 133, 39],
	[195, 131, 39],
	[192, 130, 39],
	[190, 128, 39],
	[187, 127, 39],
	[185, 125, 39],
	[182, 123, 38],
	[180, 122, 38],
	[177, 120, 38],
	[175, 119, 38],
	[172, 117, 38],
	[170, 115, 38],
	[168, 114, 38],
	[165, 112, 37],
	[163, 110, 37],
	[160, 109, 37],
	[158, 107, 37],
	[155, 106, 37],
	[153, 104, 37],
	[150, 102, 37],
	[148, 101, 36],
	[146, 99, 36],
	[143, 98, 36],
	[141, 96, 36],
	[138, 94, 36],
	[136, 93, 36],
	[133, 91, 36],
	[131, 89, 35],
	[128, 88, 35],
	[126, 86, 35],
	[124, 85, 35],
	[121, 83, 35],
	[119, 81, 35],
	[116, 80, 35],
	[114, 78, 34],
	[111, 77, 34],
	[109, 75, 34],
	[106, 73, 34],
	[104, 72, 34],
	[102, 70, 34],
	[99, 68, 34],
	[97, 67, 33],
	[94, 65, 33],
	[92, 64, 33],
	[89, 62, 33],
	[87, 60, 33],
	[84, 59, 33],
	[82, 57, 33],
	[80, 56, 33]
];

export let temp_div = [
	[5, 48, 97],
	[6, 49, 98],
	[7, 51, 100],
	[8, 53, 102],
	[9, 55, 104],
	[11, 57, 106],
	[12, 59, 108],
	[13, 61, 110],
	[14, 63, 112],
	[15, 65, 114],
	[17, 67, 116],
	[18, 69, 118],
	[19, 71, 120],
	[20, 73, 121],
	[22, 75, 123],
	[23, 77, 125],
	[24, 79, 127],
	[25, 81, 129],
	[26, 82, 131],
	[28, 84, 133],
	[29, 86, 135],
	[30, 88, 137],
	[31, 90, 139],
	[32, 92, 141],
	[34, 94, 143],
	[35, 96, 145],
	[36, 98, 146],
	[37, 100, 148],
	[39, 102, 150],
	[40, 104, 152],
	[41, 106, 154],
	[42, 108, 156],
	[43, 110, 158],
	[45, 112, 160],
	[46, 113, 162],
	[47, 115, 164],
	[48, 117, 166],
	[49, 119, 168],
	[51, 121, 170],
	[52, 123, 171],
	[53, 125, 173],
	[54, 127, 175],
	[56, 129, 177],
	[57, 131, 179],
	[58, 133, 181],
	[59, 135, 183],
	[60, 137, 185],
	[62, 139, 187],
	[63, 141, 189],
	[64, 143, 191],
	[65, 145, 193],
	[67, 147, 195],
	[69, 148, 195],
	[71, 149, 196],
	[74, 150, 197],
	[76, 152, 197],
	[78, 153, 198],
	[81, 155, 199],
	[83, 156, 199],
	[86, 157, 200],
	[88, 159, 201],
	[90, 160, 202],
	[93, 161, 202],
	[95, 163, 203],
	[97, 164, 204],
	[100, 165, 204],
	[102, 166, 205],
	[105, 168, 206],
	[107, 169, 207],
	[109, 171, 207],
	[112, 172, 208],
	[114, 173, 209],
	[116, 175, 209],
	[119, 176, 210],
	[121, 177, 211],
	[124, 179, 211],
	[126, 180, 212],
	[128, 181, 213],
	[131, 183, 214],
	[133, 184, 214],
	[135, 185, 215],
	[138, 187, 216],
	[140, 188, 216],
	[143, 189, 217],
	[145, 191, 218],
	[147, 192, 219],
	[150, 193, 219],
	[152, 195, 220],
	[155, 196, 221],
	[157, 197, 221],
	[159, 198, 222],
	[162, 200, 223],
	[164, 201, 223],
	[166, 203, 224],
	[169, 204, 225],
	[171, 205, 226],
	[174, 207, 226],
	[176, 208, 227],
	[178, 209, 228],
	[181, 211, 228],
	[183, 212, 229],
	[185, 213, 230],
	[188, 214, 230],
	[190, 216, 231],
	[193, 217, 232],
	[195, 219, 233],
	[197, 220, 233],
	[200, 221, 234],
	[202, 223, 235],
	[204, 224, 235],
	[207, 225, 236],
	[209, 227, 237],
	[212, 228, 238],
	[214, 229, 238],
	[216, 230, 239],
	[219, 232, 240],
	[221, 233, 240],
	[224, 235, 241],
	[226, 236, 242],
	[228, 237, 243],
	[231, 239, 243],
	[233, 240, 244],
	[235, 241, 245],
	[238, 243, 245],
	[240, 244, 246],
	[243, 245, 247],
	[245, 246, 247],
	[247, 248, 248],
	[248, 248, 247],
	[248, 246, 245],
	[247, 243, 243],
	[247, 242, 241],
	[246, 240, 238],
	[246, 238, 236],
	[246, 235, 234],
	[245, 234, 232],
	[245, 232, 229],
	[244, 230, 227],
	[244, 227, 225],
	[243, 226, 223],
	[243, 224, 220],
	[242, 222, 218],
	[242, 220, 216],
	[241, 218, 214],
	[241, 216, 211],
	[240, 214, 209],
	[240, 211, 207],
	[240, 210, 205],
	[239, 208, 202],
	[239, 206, 200],
	[238, 203, 198],
	[238, 202, 196],
	[237, 200, 193],
	[237, 198, 191],
	[236, 195, 189],
	[236, 194, 187],
	[235, 192, 184],
	[235, 190, 182],
	[235, 187, 180],
	[234, 186, 178],
	[234, 184, 175],
	[233, 181, 173],
	[233, 179, 171],
	[232, 178, 169],
	[232, 176, 166],
	[231, 174, 164],
	[231, 172, 162],
	[230, 170, 160],
	[230, 168, 157],
	[230, 166, 155],
	[229, 163, 153],
	[229, 162, 151],
	[228, 160, 148],
	[228, 158, 146],
	[227, 156, 144],
	[227, 154, 142],
	[226, 152, 139],
	[226, 149, 137],
	[225, 147, 135],
	[225, 146, 133],
	[224, 144, 130],
	[224, 142, 128],
	[224, 140, 126],
	[223, 138, 124],
	[223, 135, 121],
	[222, 134, 119],
	[222, 132, 117],
	[221, 130, 115],
	[221, 128, 112],
	[220, 125, 110],
	[220, 124, 108],
	[219, 121, 106],
	[219, 120, 103],
	[219, 118, 101],
	[218, 115, 99],
	[218, 113, 97],
	[217, 112, 94],
	[217, 110, 92],
	[216, 108, 90],
	[216, 105, 88],
	[215, 104, 85],
	[215, 102, 83],
	[214, 100, 81],
	[214, 97, 79],
	[214, 96, 76],
	[211, 94, 76],
	[209, 92, 75],
	[207, 90, 74],
	[205, 88, 73],
	[203, 86, 72],
	[200, 84, 71],
	[198, 82, 70],
	[196, 80, 69],
	[194, 79, 68],
	[192, 77, 67],
	[190, 75, 67],
	[187, 73, 66],
	[185, 71, 65],
	[183, 69, 64],
	[181, 67, 63],
	[179, 65, 62],
	[177, 64, 61],
	[174, 62, 60],
	[172, 60, 59],
	[170, 58, 58],
	[168, 56, 58],
	[166, 54, 57],
	[163, 52, 56],
	[161, 50, 55],
	[159, 48, 54],
	[157, 47, 53],
	[155, 45, 52],
	[153, 43, 51],
	[150, 41, 50],
	[148, 39, 49],
	[146, 37, 49],
	[144, 35, 48],
	[142, 33, 47],
	[140, 32, 46],
	[137, 30, 45],
	[135, 28, 44],
	[133, 26, 43],
	[131, 24, 42],
	[129, 22, 41],
	[126, 20, 40],
	[124, 18, 40],
	[122, 16, 39],
	[120, 15, 38],
	[118, 13, 37],
	[116, 11, 36],
	[113, 9, 35],
	[111, 7, 34],
	[109, 5, 33],
	[107, 3, 32],
	[105, 1, 31],
	[103, 0, 31]
];

export let wind_div = [
	[43, 25, 76],
	[43, 27, 77],
	[43, 28, 79],
	[43, 29, 80],
	[43, 31, 82],
	[43, 32, 83],
	[43, 34, 84],
	[43, 35, 86],
	[43, 37, 87],
	[43, 38, 89],
	[43, 40, 90],
	[43, 41, 92],
	[42, 42, 93],
	[42, 44, 94],
	[42, 45, 96],
	[42, 47, 97],
	[42, 48, 99],
	[42, 50, 100],
	[42, 51, 102],
	[42, 53, 103],
	[42, 54, 105],
	[41, 55, 106],
	[41, 57, 108],
	[41, 58, 109],
	[41, 60, 111],
	[41, 61, 112],
	[41, 63, 114],
	[41, 64, 115],
	[41, 66, 117],
	[41, 68, 118],
	[41, 69, 120],
	[42, 71, 121],
	[42, 72, 123],
	[42, 74, 124],
	[43, 75, 126],
	[43, 77, 127],
	[43, 79, 129],
	[44, 80, 130],
	[45, 82, 131],
	[46, 84, 133],
	[46, 85, 134],
	[47, 87, 136],
	[48, 89, 137],
	[49, 90, 139],
	[51, 92, 140],
	[52, 94, 141],
	[53, 95, 143],
	[55, 97, 144],
	[56, 99, 146],
	[58, 100, 147],
	[59, 102, 148],
	[61, 104, 149],
	[63, 105, 151],
	[64, 107, 152],
	[66, 109, 153],
	[68, 111, 155],
	[70, 112, 156],
	[72, 114, 157],
	[74, 116, 158],
	[76, 117, 159],
	[78, 119, 161],
	[80, 121, 162],
	[82, 122, 163],
	[84, 124, 164],
	[86, 126, 165],
	[88, 127, 167],
	[90, 129, 168],
	[92, 131, 169],
	[94, 132, 170],
	[97, 134, 171],
	[99, 136, 172],
	[101, 137, 174],
	[103, 139, 175],
	[105, 141, 176],
	[107, 142, 177],
	[109, 144, 178],
	[112, 146, 179],
	[114, 147, 181],
	[116, 149, 182],
	[118, 151, 183],
	[120, 153, 184],
	[123, 154, 185],
	[125, 156, 186],
	[127, 158, 188],
	[129, 159, 189],
	[131, 161, 190],
	[134, 163, 191],
	[136, 164, 192],
	[138, 166, 193],
	[140, 168, 195],
	[143, 170, 196],
	[145, 171, 197],
	[147, 173, 198],
	[149, 175, 199],
	[152, 176, 201],
	[154, 178, 202],
	[156, 180, 203],
	[158, 182, 204],
	[161, 183, 205],
	[163, 185, 206],
	[165, 187, 208],
	[167, 188, 209],
	[170, 190, 210],
	[172, 192, 211],
	[174, 194, 212],
	[177, 195, 214],
	[179, 197, 215],
	[181, 199, 216],
	[183, 201, 217],
	[186, 202, 218],
	[188, 204, 219],
	[190, 206, 220],
	[192, 207, 222],
	[195, 209, 223],
	[197, 211, 224],
	[199, 213, 225],
	[201, 214, 225],
	[203, 216, 226],
	[205, 217, 227],
	[207, 219, 228],
	[209, 221, 228],
	[210, 222, 229],
	[212, 223, 229],
	[214, 225, 230],
	[215, 226, 230],
	[216, 227, 230],
	[217, 228, 229],
	[218, 229, 229],
	[218, 230, 228],
	[218, 230, 228],
	[218, 231, 227],
	[218, 231, 226],
	[218, 231, 224],
	[217, 231, 223],
	[216, 231, 221],
	[215, 230, 220],
	[214, 230, 218],
	[213, 229, 216],
	[211, 228, 215],
	[210, 228, 213],
	[208, 227, 211],
	[206, 226, 209],
	[204, 225, 207],
	[202, 224, 205],
	[201, 223, 203],
	[199, 222, 201],
	[197, 221, 199],
	[195, 219, 197],
	[193, 218, 195],
	[191, 217, 193],
	[189, 216, 191],
	[187, 215, 189],
	[185, 214, 187],
	[183, 212, 185],
	[181, 211, 183],
	[179, 210, 181],
	[177, 209, 179],
	[174, 208, 177],
	[172, 207, 175],
	[170, 205, 173],
	[168, 204, 171],
	[166, 203, 170],
	[164, 202, 168],
	[162, 201, 166],
	[160, 199, 164],
	[158, 198, 162],
	[156, 197, 160],
	[154, 196, 158],
	[152, 195, 156],
	[150, 193, 154],
	[148, 192, 152],
	[146, 191, 150],
	[144, 190, 148],
	[142, 189, 146],
	[140, 188, 144],
	[138, 186, 142],
	[136, 185, 140],
	[134, 184, 138],
	[132, 183, 137],
	[130, 182, 135],
	[128, 181, 133],
	[126, 179, 131],
	[124, 178, 129],
	[122, 177, 127],
	[120, 176, 125],
	[118, 175, 123],
	[116, 173, 121],
	[114, 172, 119],
	[112, 171, 117],
	[111, 170, 115],
	[109, 169, 113],
	[107, 167, 111],
	[105, 166, 109],
	[103, 165, 107],
	[101, 164, 105],
	[99, 162, 103],
	[97, 161, 101],
	[95, 160, 99],
	[93, 158, 97],
	[91, 157, 95],
	[89, 155, 93],
	[88, 154, 91],
	[86, 153, 89],
	[84, 151, 87],
	[82, 150, 84],
	[81, 148, 82],
	[79, 146, 80],
	[78, 145, 78],
	[76, 143, 76],
	[75, 141, 73],
	[73, 140, 71],
	[72, 138, 69],
	[71, 136, 67],
	[70, 135, 65],
	[69, 133, 62],
	[68, 131, 60],
	[68, 129, 58],
	[67, 128, 56],
	[66, 126, 54],
	[66, 124, 52],
	[65, 123, 51],
	[65, 121, 49],
	[65, 119, 47],
	[64, 118, 45],
	[64, 116, 44],
	[64, 115, 42],
	[64, 113, 40],
	[64, 112, 39],
	[64, 110, 37],
	[64, 109, 36],
	[64, 107, 34],
	[64, 106, 33],
	[64, 105, 32],
	[64, 103, 30],
	[64, 102, 29],
	[64, 101, 28],
	[64, 99, 26],
	[65, 98, 25],
	[65, 97, 24],
	[65, 95, 22],
	[65, 94, 21],
	[65, 93, 20],
	[65, 92, 18],
	[65, 90, 17],
	[65, 89, 16],
	[65, 88, 15],
	[65, 87, 13],
	[66, 86, 12],
	[66, 84, 11],
	[66, 83, 9],
	[66, 82, 8],
	[66, 81, 7],
	[66, 80, 5],
	[66, 78, 4],
	[66, 77, 3],
	[66, 76, 2]
];

export let misc_seq = [
	[25, 51, 178],
	[26, 51, 178],
	[26, 52, 177],
	[27, 53, 177],
	[27, 53, 177],
	[28, 54, 176],
	[28, 55, 176],
	[28, 56, 176],
	[29, 56, 175],
	[29, 57, 175],
	[29, 58, 175],
	[30, 58, 174],
	[30, 59, 174],
	[31, 60, 174],
	[31, 60, 173],
	[31, 61, 173],
	[32, 62, 172],
	[32, 62, 172],
	[32, 63, 172],
	[33, 64, 171],
	[33, 65, 171],
	[33, 65, 171],
	[34, 66, 170],
	[34, 67, 170],
	[34, 67, 170],
	[35, 68, 169],
	[35, 69, 169],
	[35, 69, 169],
	[36, 70, 168],
	[36, 71, 168],
	[36, 71, 168],
	[37, 72, 167],
	[37, 72, 167],
	[37, 73, 167],
	[38, 74, 166],
	[38, 74, 166],
	[38, 75, 166],
	[39, 76, 165],
	[39, 76, 165],
	[39, 77, 165],
	[40, 78, 164],
	[40, 78, 164],
	[40, 79, 164],
	[40, 80, 163],
	[41, 80, 163],
	[41, 81, 163],
	[41, 82, 162],
	[42, 82, 162],
	[42, 83, 162],
	[42, 84, 161],
	[43, 84, 161],
	[43, 85, 161],
	[43, 86, 160],
	[44, 86, 160],
	[44, 87, 160],
	[44, 88, 159],
	[45, 88, 159],
	[45, 89, 159],
	[45, 90, 158],
	[46, 90, 158],
	[46, 91, 158],
	[46, 91, 157],
	[47, 92, 157],
	[47, 93, 157],
	[48, 93, 156],
	[48, 94, 156],
	[48, 95, 156],
	[49, 95, 155],
	[49, 96, 155],
	[49, 97, 154],
	[50, 97, 154],
	[50, 98, 154],
	[51, 98, 153],
	[51, 99, 153],
	[52, 100, 152],
	[52, 100, 152],
	[52, 101, 152],
	[53, 101, 151],
	[53, 102, 151],
	[54, 103, 150],
	[54, 103, 150],
	[55, 104, 149],
	[55, 104, 149],
	[56, 105, 148],
	[56, 106, 148],
	[57, 106, 147],
	[57, 107, 147],
	[58, 107, 146],
	[58, 108, 146],
	[59, 109, 145],
	[59, 109, 145],
	[60, 110, 144],
	[60, 110, 144],
	[61, 111, 143],
	[61, 111, 143],
	[62, 112, 142],
	[63, 112, 141],
	[63, 113, 141],
	[64, 114, 140],
	[64, 114, 140],
	[65, 115, 139],
	[65, 115, 139],
	[66, 116, 138],
	[66, 117, 138],
	[67, 117, 137],
	[68, 118, 137],
	[68, 118, 136],
	[69, 119, 136],
	[69, 120, 135],
	[70, 120, 135],
	[71, 121, 134],
	[71, 121, 134],
	[72, 122, 133],
	[72, 123, 133],
	[73, 123, 132],
	[74, 124, 132],
	[74, 125, 131],
	[75, 125, 131],
	[76, 126, 130],
	[77, 127, 130],
	[77, 128, 129],
	[78, 128, 129],
	[79, 129, 129],
	[79, 130, 128],
	[80, 131, 128],
	[81, 131, 127],
	[82, 132, 127],
	[83, 133, 127],
	[83, 134, 126],
	[84, 135, 126],
	[85, 135, 126],
	[86, 136, 125],
	[87, 137, 125],
	[88, 138, 125],
	[88, 139, 125],
	[89, 140, 124],
	[90, 141, 124],
	[91, 141, 124],
	[92, 142, 123],
	[93, 143, 123],
	[94, 144, 123],
	[95, 145, 123],
	[96, 146, 122],
	[96, 147, 122],
	[97, 148, 122],
	[98, 149, 122],
	[99, 150, 121],
	[100, 151, 121],
	[101, 152, 121],
	[102, 153, 121],
	[103, 153, 121],
	[104, 154, 120],
	[105, 155, 120],
	[106, 156, 120],
	[107, 157, 120],
	[108, 158, 119],
	[109, 159, 119],
	[110, 160, 119],
	[111, 161, 119],
	[112, 162, 118],
	[113, 163, 118],
	[114, 164, 118],
	[115, 165, 118],
	[115, 166, 117],
	[116, 167, 117],
	[117, 168, 117],
	[118, 169, 117],
	[119, 170, 116],
	[120, 171, 116],
	[121, 172, 116],
	[122, 173, 116],
	[123, 174, 115],
	[124, 175, 115],
	[125, 176, 115],
	[126, 177, 115],
	[127, 178, 114],
	[128, 179, 114],
	[130, 180, 114],
	[131, 181, 114],
	[132, 182, 113],
	[133, 183, 113],
	[134, 184, 113],
	[135, 185, 113],
	[136, 186, 112],
	[137, 187, 112],
	[138, 189, 112],
	[139, 190, 112],
	[140, 191, 111],
	[141, 192, 111],
	[142, 193, 111],
	[143, 194, 111],
	[144, 195, 110],
	[145, 196, 110],
	[146, 197, 110],
	[147, 198, 109],
	[148, 199, 109],
	[150, 200, 109],
	[151, 201, 109],
	[152, 202, 108],
	[153, 204, 108],
	[154, 205, 108],
	[155, 206, 108],
	[156, 207, 107],
	[158, 208, 107],
	[159, 209, 107],
	[160, 210, 107],
	[161, 211, 106],
	[163, 212, 106],
	[164, 213, 106],
	[165, 215, 106],
	[167, 216, 105],
	[168, 217, 105],
	[170, 218, 105],
	[171, 219, 105],
	[173, 220, 104],
	[174, 221, 104],
	[176, 222, 104],
	[177, 223, 104],
	[179, 224, 104],
	[181, 225, 103],
	[183, 226, 103],
	[184, 227, 103],
	[186, 228, 103],
	[188, 229, 103],
	[190, 230, 103],
	[192, 231, 103],
	[194, 232, 102],
	[196, 233, 102],
	[198, 234, 102],
	[200, 235, 102],
	[202, 236, 102],
	[204, 237, 102],
	[206, 237, 102],
	[208, 238, 102],
	[210, 239, 102],
	[212, 240, 102],
	[214, 241, 102],
	[217, 241, 102],
	[219, 242, 102],
	[221, 243, 102],
	[223, 244, 102],
	[225, 245, 102],
	[227, 245, 102],
	[229, 246, 102],
	[231, 247, 102],
	[233, 247, 102],
	[236, 248, 102],
	[238, 249, 102],
	[240, 250, 102],
	[242, 250, 102],
	[244, 251, 102],
	[246, 252, 102],
	[248, 252, 102],
	[250, 253, 102],
	[252, 254, 102],
	[255, 254, 102]
];

export let temp_seq = [
	[254, 254, 203],
	[254, 254, 202],
	[254, 253, 200],
	[254, 253, 198],
	[254, 252, 196],
	[254, 251, 195],
	[254, 251, 193],
	[254, 250, 191],
	[254, 249, 189],
	[254, 249, 187],
	[253, 248, 186],
	[253, 247, 184],
	[253, 247, 182],
	[253, 246, 180],
	[253, 245, 178],
	[253, 245, 177],
	[253, 244, 175],
	[253, 243, 173],
	[252, 243, 171],
	[252, 242, 170],
	[252, 241, 168],
	[252, 241, 166],
	[252, 240, 164],
	[252, 239, 162],
	[252, 239, 160],
	[251, 238, 159],
	[251, 237, 157],
	[251, 236, 155],
	[251, 235, 153],
	[251, 235, 151],
	[250, 234, 150],
	[250, 233, 148],
	[250, 232, 146],
	[250, 231, 144],
	[250, 230, 142],
	[249, 230, 140],
	[249, 229, 138],
	[249, 228, 137],
	[249, 227, 135],
	[249, 226, 133],
	[248, 225, 131],
	[248, 224, 129],
	[248, 223, 127],
	[248, 221, 126],
	[247, 220, 124],
	[247, 219, 122],
	[247, 218, 120],
	[247, 217, 119],
	[246, 216, 117],
	[246, 214, 115],
	[246, 213, 114],
	[245, 212, 112],
	[245, 211, 110],
	[245, 209, 109],
	[244, 208, 107],
	[244, 207, 106],
	[244, 205, 105],
	[243, 204, 103],
	[243, 202, 102],
	[243, 201, 101],
	[243, 200, 99],
	[242, 198, 98],
	[242, 197, 97],
	[242, 196, 96],
	[241, 194, 95],
	[241, 193, 94],
	[241, 191, 93],
	[240, 190, 92],
	[240, 189, 92],
	[240, 187, 91],
	[239, 186, 90],
	[239, 185, 90],
	[239, 183, 89],
	[239, 182, 88],
	[238, 181, 88],
	[238, 180, 87],
	[238, 178, 87],
	[237, 177, 87],
	[237, 176, 86],
	[237, 175, 86],
	[237, 173, 85],
	[236, 172, 85],
	[236, 171, 85],
	[236, 170, 85],
	[236, 168, 84],
	[235, 167, 84],
	[235, 166, 84],
	[235, 165, 84],
	[235, 164, 83],
	[234, 162, 83],
	[234, 161, 83],
	[234, 160, 83],
	[234, 159, 83],
	[233, 158, 83],
	[233, 157, 82],
	[233, 155, 82],
	[233, 154, 82],
	[232, 153, 82],
	[232, 152, 82],
	[232, 151, 82],
	[232, 150, 82],
	[231, 148, 82],
	[231, 147, 82],
	[231, 146, 81],
	[230, 145, 81],
	[230, 144, 81],
	[230, 143, 81],
	[230, 141, 81],
	[229, 140, 81],
	[229, 139, 81],
	[229, 138, 81],
	[228, 137, 81],
	[228, 135, 81],
	[228, 134, 80],
	[228, 133, 80],
	[227, 132, 80],
	[227, 131, 80],
	[226, 129, 80],
	[226, 128, 80],
	[226, 127, 80],
	[225, 126, 80],
	[225, 125, 80],
	[224, 123, 79],
	[224, 122, 79],
	[223, 121, 79],
	[223, 120, 79],
	[222, 118, 79],
	[222, 117, 79],
	[221, 116, 79],
	[221, 114, 79],
	[220, 113, 78],
	[219, 112, 78],
	[219, 111, 78],
	[218, 109, 78],
	[217, 108, 78],
	[216, 107, 78],
	[215, 105, 77],
	[214, 104, 77],
	[213, 103, 77],
	[212, 101, 77],
	[211, 100, 77],
	[210, 99, 76],
	[209, 98, 76],
	[208, 96, 76],
	[207, 95, 76],
	[205, 94, 75],
	[204, 92, 75],
	[203, 91, 75],
	[201, 90, 75],
	[200, 89, 74],
	[198, 88, 74],
	[197, 87, 74],
	[195, 85, 73],
	[194, 84, 73],
	[192, 83, 73],
	[190, 82, 72],
	[189, 81, 72],
	[187, 80, 72],
	[185, 79, 71],
	[184, 79, 71],
	[182, 78, 70],
	[180, 77, 70],
	[178, 76, 70],
	[177, 75, 69],
	[175, 74, 69],
	[173, 74, 68],
	[171, 73, 68],
	[170, 72, 67],
	[168, 72, 67],
	[166, 71, 66],
	[164, 70, 66],
	[162, 70, 65],
	[161, 69, 65],
	[159, 69, 64],
	[157, 68, 63],
	[155, 67, 63],
	[153, 67, 62],
	[152, 66, 62],
	[150, 66, 61],
	[148, 65, 60],
	[146, 65, 60],
	[144, 64, 59],
	[143, 64, 58],
	[141, 63, 58],
	[139, 63, 57],
	[137, 62, 56],
	[135, 62, 56],
	[134, 61, 55],
	[132, 61, 54],
	[130, 60, 53],
	[128, 59, 53],
	[127, 59, 52],
	[125, 58, 51],
	[123, 58, 50],
	[121, 57, 50],
	[119, 57, 49],
	[118, 56, 48],
	[116, 56, 47],
	[114, 55, 46],
	[112, 55, 46],
	[111, 54, 45],
	[109, 54, 44],
	[107, 53, 43],
	[106, 53, 42],
	[104, 52, 42],
	[102, 52, 41],
	[100, 51, 40],
	[99, 50, 39],
	[97, 50, 38],
	[95, 49, 38],
	[94, 49, 37],
	[92, 48, 36],
	[90, 48, 35],
	[89, 47, 34],
	[87, 47, 33],
	[85, 46, 33],
	[84, 46, 32],
	[82, 45, 31],
	[80, 45, 30],
	[79, 44, 30],
	[77, 43, 29],
	[75, 43, 28],
	[74, 42, 27],
	[72, 42, 27],
	[71, 41, 26],
	[69, 41, 25],
	[67, 40, 24],
	[66, 40, 24],
	[64, 39, 23],
	[63, 39, 22],
	[61, 38, 22],
	[59, 38, 21],
	[58, 37, 20],
	[56, 37, 20],
	[55, 36, 19],
	[53, 36, 18],
	[52, 35, 18],
	[50, 35, 17],
	[49, 34, 16],
	[47, 34, 15],
	[46, 33, 15],
	[44, 33, 14],
	[43, 32, 13],
	[41, 31, 12],
	[40, 31, 11],
	[39, 30, 10],
	[37, 30, 9],
	[36, 29, 8],
	[34, 29, 7],
	[33, 28, 6],
	[32, 28, 5],
	[30, 27, 4],
	[29, 27, 3],
	[28, 26, 2],
	[26, 26, 1],
	[25, 25, 0]
];

export let chem_seq = [
	[254, 254, 216],
	[253, 254, 215],
	[251, 253, 214],
	[250, 253, 213],
	[249, 253, 212],
	[247, 253, 211],
	[246, 253, 211],
	[245, 252, 210],
	[244, 252, 209],
	[242, 252, 208],
	[241, 251, 207],
	[240, 251, 206],
	[238, 251, 205],
	[237, 250, 204],
	[235, 250, 203],
	[234, 250, 202],
	[232, 249, 201],
	[231, 249, 200],
	[229, 248, 199],
	[228, 248, 198],
	[226, 247, 197],
	[225, 246, 195],
	[223, 246, 194],
	[221, 245, 193],
	[220, 244, 192],
	[218, 244, 191],
	[216, 243, 190],
	[215, 242, 189],
	[213, 241, 187],
	[211, 240, 186],
	[209, 239, 185],
	[207, 238, 184],
	[206, 237, 183],
	[204, 236, 181],
	[202, 235, 180],
	[200, 234, 179],
	[198, 233, 178],
	[196, 232, 177],
	[195, 231, 175],
	[193, 229, 174],
	[191, 228, 173],
	[189, 227, 172],
	[188, 226, 171],
	[186, 224, 170],
	[184, 223, 169],
	[183, 221, 168],
	[181, 220, 166],
	[179, 219, 165],
	[178, 217, 164],
	[176, 216, 163],
	[175, 215, 163],
	[174, 213, 162],
	[172, 212, 161],
	[171, 210, 160],
	[170, 209, 159],
	[169, 208, 158],
	[168, 206, 157],
	[166, 205, 157],
	[165, 204, 156],
	[164, 203, 155],
	[163, 201, 155],
	[163, 200, 154],
	[162, 199, 153],
	[161, 198, 153],
	[160, 196, 152],
	[159, 195, 152],
	[159, 194, 151],
	[158, 193, 151],
	[157, 192, 150],
	[157, 190, 150],
	[156, 189, 149],
	[156, 188, 149],
	[155, 187, 149],
	[155, 186, 148],
	[154, 185, 148],
	[154, 184, 147],
	[154, 183, 147],
	[153, 182, 147],
	[153, 181, 146],
	[152, 180, 146],
	[152, 179, 146],
	[152, 178, 145],
	[151, 177, 145],
	[151, 176, 145],
	[151, 175, 144],
	[151, 174, 144],
	[150, 173, 144],
	[150, 172, 144],
	[150, 171, 143],
	[150, 170, 143],
	[149, 169, 143],
	[149, 168, 143],
	[149, 167, 142],
	[149, 166, 142],
	[148, 165, 142],
	[148, 164, 142],
	[148, 163, 141],
	[148, 162, 141],
	[148, 161, 141],
	[148, 160, 140],
	[147, 159, 140],
	[147, 158, 140],
	[147, 157, 140],
	[147, 157, 139],
	[147, 156, 139],
	[147, 155, 139],
	[146, 154, 139],
	[146, 153, 138],
	[146, 152, 138],
	[146, 151, 138],
	[146, 150, 138],
	[146, 149, 137],
	[145, 148, 137],
	[145, 147, 137],
	[145, 146, 137],
	[145, 146, 136],
	[145, 145, 136],
	[145, 144, 136],
	[144, 143, 136],
	[144, 142, 135],
	[144, 141, 135],
	[144, 140, 135],
	[144, 139, 135],
	[144, 138, 134],
	[144, 137, 134],
	[143, 136, 134],
	[143, 135, 134],
	[143, 135, 133],
	[143, 134, 133],
	[143, 133, 133],
	[143, 132, 133],
	[142, 131, 132],
	[142, 130, 132],
	[142, 129, 132],
	[142, 128, 132],
	[142, 127, 131],
	[142, 126, 131],
	[141, 125, 131],
	[141, 125, 130],
	[141, 124, 130],
	[141, 123, 130],
	[141, 122, 130],
	[140, 121, 129],
	[140, 120, 129],
	[140, 119, 129],
	[140, 118, 129],
	[140, 117, 128],
	[139, 116, 128],
	[139, 115, 128],
	[139, 114, 127],
	[139, 113, 127],
	[139, 112, 127],
	[138, 111, 126],
	[138, 111, 126],
	[138, 110, 126],
	[138, 109, 125],
	[137, 108, 125],
	[137, 107, 125],
	[137, 106, 124],
	[136, 105, 124],
	[136, 104, 124],
	[136, 103, 123],
	[135, 102, 123],
	[135, 101, 123],
	[135, 100, 122],
	[134, 99, 122],
	[134, 98, 121],
	[133, 97, 121],
	[133, 96, 121],
	[133, 95, 120],
	[132, 94, 120],
	[132, 93, 119],
	[131, 91, 119],
	[131, 90, 118],
	[130, 89, 118],
	[130, 88, 117],
	[129, 87, 117],
	[128, 86, 116],
	[128, 85, 116],
	[127, 84, 115],
	[126, 83, 115],
	[126, 82, 114],
	[125, 80, 114],
	[124, 79, 113],
	[124, 78, 112],
	[123, 77, 112],
	[122, 76, 111],
	[121, 75, 111],
	[120, 73, 110],
	[119, 72, 109],
	[118, 71, 108],
	[117, 70, 108],
	[116, 69, 107],
	[115, 68, 106],
	[114, 66, 106],
	[113, 65, 105],
	[112, 64, 104],
	[111, 63, 103],
	[110, 62, 102],
	[109, 60, 102],
	[107, 59, 101],
	[106, 58, 100],
	[105, 57, 99],
	[104, 56, 98],
	[102, 54, 97],
	[101, 53, 96],
	[100, 52, 95],
	[98, 51, 95],
	[97, 50, 94],
	[96, 49, 93],
	[94, 48, 92],
	[93, 46, 91],
	[91, 45, 90],
	[90, 44, 89],
	[88, 43, 88],
	[87, 42, 87],
	[85, 41, 86],
	[84, 40, 85],
	[82, 39, 84],
	[81, 38, 83],
	[79, 37, 82],
	[78, 36, 81],
	[76, 35, 80],
	[75, 34, 79],
	[73, 34, 78],
	[72, 33, 78],
	[70, 32, 77],
	[68, 31, 76],
	[67, 30, 75],
	[65, 29, 74],
	[64, 29, 73],
	[62, 28, 72],
	[61, 27, 71],
	[59, 27, 70],
	[58, 26, 69],
	[56, 25, 68],
	[55, 24, 67],
	[53, 24, 66],
	[52, 23, 66],
	[50, 23, 65],
	[49, 22, 64],
	[47, 21, 63],
	[46, 21, 62],
	[44, 20, 61],
	[43, 20, 60],
	[41, 19, 59],
	[40, 19, 59],
	[38, 18, 58],
	[37, 18, 57],
	[35, 17, 56],
	[34, 17, 55],
	[32, 16, 54],
	[31, 16, 54],
	[29, 15, 53],
	[27, 15, 52],
	[26, 14, 51]
];

export let prec_seq = [
	[255, 255, 229],
	[253, 254, 228],
	[252, 253, 227],
	[251, 252, 227],
	[249, 252, 226],
	[248, 251, 226],
	[247, 250, 225],
	[245, 250, 225],
	[244, 249, 224],
	[243, 248, 223],
	[241, 248, 223],
	[240, 247, 222],
	[239, 246, 222],
	[237, 246, 221],
	[236, 245, 221],
	[235, 244, 220],
	[233, 244, 220],
	[232, 243, 219],
	[231, 242, 218],
	[229, 242, 218],
	[228, 241, 217],
	[227, 240, 217],
	[225, 240, 216],
	[224, 239, 216],
	[223, 238, 215],
	[221, 238, 214],
	[220, 237, 214],
	[219, 236, 213],
	[218, 235, 213],
	[216, 235, 212],
	[215, 234, 212],
	[214, 233, 211],
	[212, 233, 211],
	[211, 232, 210],
	[210, 231, 209],
	[208, 231, 209],
	[207, 230, 208],
	[206, 229, 208],
	[204, 229, 207],
	[203, 228, 207],
	[202, 227, 206],
	[200, 227, 205],
	[199, 226, 205],
	[198, 225, 204],
	[196, 225, 204],
	[195, 224, 203],
	[194, 223, 203],
	[192, 223, 202],
	[191, 222, 202],
	[190, 221, 201],
	[188, 221, 200],
	[187, 220, 200],
	[186, 219, 199],
	[185, 218, 199],
	[183, 218, 198],
	[182, 217, 198],
	[181, 216, 197],
	[179, 216, 196],
	[178, 215, 196],
	[177, 214, 195],
	[175, 214, 195],
	[174, 213, 194],
	[173, 212, 194],
	[171, 212, 193],
	[170, 211, 193],
	[169, 210, 192],
	[167, 210, 191],
	[166, 209, 191],
	[165, 208, 190],
	[163, 208, 190],
	[162, 207, 189],
	[161, 206, 189],
	[159, 206, 188],
	[158, 205, 187],
	[157, 204, 187],
	[155, 204, 186],
	[154, 203, 186],
	[153, 202, 185],
	[152, 201, 185],
	[150, 201, 184],
	[149, 200, 184],
	[148, 199, 183],
	[146, 199, 182],
	[145, 198, 182],
	[144, 197, 181],
	[142, 197, 181],
	[141, 196, 180],
	[140, 195, 180],
	[138, 195, 179],
	[137, 194, 178],
	[136, 193, 178],
	[134, 193, 177],
	[133, 192, 177],
	[132, 191, 176],
	[130, 191, 176],
	[129, 190, 175],
	[128, 189, 175],
	[126, 189, 174],
	[125, 188, 173],
	[124, 187, 173],
	[122, 187, 172],
	[121, 186, 172],
	[120, 185, 171],
	[119, 184, 171],
	[117, 184, 170],
	[116, 183, 169],
	[115, 182, 169],
	[113, 182, 168],
	[112, 181, 168],
	[111, 180, 167],
	[109, 180, 167],
	[108, 179, 166],
	[107, 178, 166],
	[105, 178, 165],
	[104, 177, 164],
	[103, 176, 164],
	[101, 176, 163],
	[100, 175, 163],
	[99, 174, 162],
	[97, 174, 162],
	[96, 173, 161],
	[95, 172, 160],
	[93, 172, 160],
	[92, 171, 159],
	[91, 170, 159],
	[89, 170, 158],
	[88, 169, 158],
	[87, 168, 157],
	[86, 167, 157],
	[84, 167, 156],
	[83, 166, 155],
	[82, 165, 155],
	[80, 165, 154],
	[79, 164, 154],
	[78, 163, 153],
	[76, 163, 153],
	[75, 162, 152],
	[74, 161, 151],
	[72, 161, 151],
	[71, 160, 150],
	[70, 159, 150],
	[68, 159, 149],
	[67, 158, 149],
	[66, 157, 148],
	[64, 157, 148],
	[63, 156, 147],
	[62, 155, 146],
	[60, 155, 146],
	[59, 154, 145],
	[58, 153, 145],
	[56, 153, 144],
	[55, 152, 144],
	[54, 151, 143],
	[53, 151, 143],
	[52, 150, 142],
	[51, 149, 141],
	[51, 148, 140],
	[50, 147, 139],
	[50, 146, 138],
	[49, 145, 137],
	[49, 144, 136],
	[48, 143, 135],
	[48, 142, 134],
	[47, 142, 133],
	[47, 141, 132],
	[46, 140, 131],
	[46, 139, 130],
	[45, 138, 129],
	[45, 137, 129],
	[44, 136, 128],
	[44, 135, 127],
	[43, 134, 126],
	[43, 134, 125],
	[42, 133, 124],
	[42, 132, 123],
	[41, 131, 122],
	[41, 130, 121],
	[40, 129, 120],
	[40, 128, 119],
	[39, 127, 118],
	[38, 126, 117],
	[38, 126, 116],
	[37, 125, 115],
	[37, 124, 115],
	[36, 123, 114],
	[36, 122, 113],
	[35, 121, 112],
	[35, 120, 111],
	[34, 119, 110],
	[34, 118, 109],
	[33, 117, 108],
	[33, 117, 107],
	[32, 116, 106],
	[32, 115, 105],
	[31, 114, 104],
	[31, 113, 103],
	[30, 112, 102],
	[30, 111, 102],
	[29, 110, 101],
	[29, 109, 100],
	[28, 109, 99],
	[28, 108, 98],
	[27, 107, 97],
	[27, 106, 96],
	[26, 105, 95],
	[25, 104, 94],
	[25, 103, 93],
	[24, 102, 92],
	[24, 101, 91],
	[23, 101, 90],
	[23, 100, 89],
	[22, 99, 88],
	[22, 98, 88],
	[21, 97, 87],
	[21, 96, 86],
	[20, 95, 85],
	[20, 94, 84],
	[19, 93, 83],
	[19, 93, 82],
	[18, 92, 81],
	[18, 91, 80],
	[17, 90, 79],
	[17, 89, 78],
	[16, 88, 77],
	[16, 87, 76],
	[15, 86, 75],
	[15, 85, 75],
	[14, 84, 74],
	[14, 84, 73],
	[13, 83, 72],
	[12, 82, 71],
	[12, 81, 70],
	[11, 80, 69],
	[11, 79, 68],
	[10, 78, 67],
	[10, 77, 66],
	[9, 76, 65],
	[9, 76, 64],
	[8, 75, 63],
	[8, 74, 62],
	[7, 73, 61],
	[7, 72, 61],
	[6, 71, 60],
	[6, 70, 59],
	[5, 69, 58],
	[5, 68, 57],
	[4, 68, 56],
	[4, 67, 55],
	[3, 66, 54],
	[3, 65, 53],
	[2, 64, 52],
	[2, 63, 51],
	[1, 62, 50],
	[1, 61, 49],
	[0, 60, 48],
	[0, 60, 48]
];

export let cryo_seq = [
	[0, 1, 0],
	[1, 2, 2],
	[1, 3, 4],
	[2, 4, 6],
	[3, 5, 9],
	[3, 6, 11],
	[4, 7, 13],
	[4, 9, 14],
	[5, 10, 16],
	[5, 11, 17],
	[6, 12, 19],
	[6, 13, 20],
	[7, 14, 21],
	[8, 15, 23],
	[8, 16, 24],
	[9, 16, 25],
	[10, 17, 26],
	[10, 18, 27],
	[11, 19, 28],
	[11, 20, 30],
	[11, 20, 31],
	[12, 21, 32],
	[12, 22, 33],
	[12, 23, 34],
	[12, 23, 36],
	[13, 24, 37],
	[13, 25, 38],
	[13, 25, 39],
	[13, 26, 41],
	[13, 27, 42],
	[13, 28, 43],
	[13, 28, 44],
	[13, 29, 46],
	[14, 30, 47],
	[14, 31, 48],
	[14, 31, 50],
	[14, 32, 51],
	[14, 33, 52],
	[14, 34, 54],
	[15, 35, 55],
	[15, 35, 56],
	[15, 36, 58],
	[15, 37, 59],
	[15, 38, 60],
	[15, 39, 62],
	[16, 40, 63],
	[16, 40, 65],
	[16, 41, 66],
	[16, 42, 67],
	[17, 43, 69],
	[17, 44, 70],
	[17, 45, 72],
	[17, 45, 73],
	[18, 46, 75],
	[18, 47, 76],
	[18, 48, 77],
	[18, 49, 79],
	[19, 50, 80],
	[19, 51, 82],
	[19, 52, 83],
	[20, 53, 85],
	[20, 54, 86],
	[20, 54, 88],
	[21, 55, 89],
	[21, 56, 91],
	[21, 57, 92],
	[22, 58, 94],
	[22, 59, 95],
	[22, 60, 97],
	[23, 61, 98],
	[23, 62, 100],
	[24, 63, 101],
	[24, 64, 103],
	[24, 65, 104],
	[25, 65, 106],
	[25, 66, 107],
	[26, 67, 109],
	[26, 68, 110],
	[27, 69, 112],
	[27, 70, 113],
	[28, 71, 115],
	[28, 72, 116],
	[29, 73, 118],
	[29, 74, 120],
	[30, 75, 121],
	[30, 76, 123],
	[31, 77, 124],
	[32, 78, 126],
	[32, 79, 127],
	[33, 80, 129],
	[34, 80, 130],
	[34, 81, 132],
	[35, 82, 134],
	[36, 83, 135],
	[36, 84, 137],
	[37, 85, 138],
	[38, 86, 140],
	[39, 87, 141],
	[40, 88, 143],
	[40, 89, 145],
	[41, 90, 146],
	[42, 91, 148],
	[43, 92, 149],
	[44, 93, 151],
	[45, 94, 153],
	[46, 95, 154],
	[47, 96, 156],
	[48, 97, 157],
	[50, 99, 159],
	[51, 100, 161],
	[52, 101, 162],
	[53, 102, 164],
	[55, 103, 165],
	[56, 104, 167],
	[57, 105, 169],
	[59, 106, 170],
	[60, 108, 172],
	[62, 109, 173],
	[63, 110, 175],
	[65, 111, 176],
	[66, 112, 178],
	[68, 114, 179],
	[69, 115, 180],
	[71, 116, 182],
	[72, 117, 183],
	[74, 119, 184],
	[76, 120, 185],
	[77, 121, 187],
	[79, 122, 188],
	[81, 123, 189],
	[82, 125, 190],
	[84, 126, 191],
	[86, 127, 192],
	[87, 128, 193],
	[89, 129, 193],
	[90, 130, 194],
	[92, 131, 195],
	[94, 133, 196],
	[95, 134, 196],
	[97, 135, 197],
	[98, 136, 197],
	[99, 137, 198],
	[101, 138, 198],
	[102, 139, 199],
	[104, 139, 199],
	[105, 140, 199],
	[106, 141, 200],
	[108, 142, 200],
	[109, 143, 200],
	[110, 144, 200],
	[112, 145, 200],
	[113, 146, 201],
	[114, 146, 201],
	[116, 147, 201],
	[117, 148, 201],
	[118, 149, 201],
	[119, 150, 201],
	[121, 150, 201],
	[122, 151, 201],
	[123, 152, 201],
	[124, 153, 201],
	[125, 153, 201],
	[127, 154, 201],
	[128, 155, 201],
	[129, 156, 201],
	[130, 156, 201],
	[131, 157, 201],
	[132, 158, 201],
	[134, 159, 201],
	[135, 159, 201],
	[136, 160, 201],
	[137, 161, 201],
	[138, 161, 201],
	[140, 162, 201],
	[141, 163, 201],
	[142, 164, 201],
	[143, 164, 201],
	[144, 165, 201],
	[145, 166, 201],
	[147, 167, 201],
	[148, 167, 201],
	[149, 168, 201],
	[150, 169, 201],
	[151, 170, 201],
	[153, 170, 201],
	[154, 171, 201],
	[155, 172, 201],
	[156, 173, 201],
	[157, 173, 201],
	[159, 174, 201],
	[160, 175, 201],
	[161, 176, 201],
	[162, 177, 201],
	[164, 177, 201],
	[165, 178, 201],
	[166, 179, 201],
	[167, 180, 202],
	[169, 181, 202],
	[170, 182, 202],
	[171, 182, 202],
	[172, 183, 202],
	[174, 184, 202],
	[175, 185, 203],
	[176, 186, 203],
	[178, 187, 203],
	[179, 188, 203],
	[180, 189, 204],
	[182, 190, 204],
	[183, 191, 205],
	[185, 192, 205],
	[186, 193, 205],
	[187, 194, 206],
	[189, 195, 206],
	[190, 196, 207],
	[192, 197, 208],
	[193, 199, 208],
	[195, 200, 209],
	[196, 201, 209],
	[198, 202, 210],
	[199, 203, 211],
	[200, 205, 212],
	[202, 206, 213],
	[203, 207, 213],
	[205, 208, 214],
	[207, 210, 215],
	[208, 211, 216],
	[210, 212, 217],
	[211, 214, 218],
	[213, 215, 219],
	[214, 216, 220],
	[216, 218, 221],
	[217, 219, 222],
	[219, 221, 224],
	[220, 222, 225],
	[222, 223, 226],
	[223, 225, 227],
	[225, 226, 228],
	[227, 228, 230],
	[228, 229, 231],
	[230, 231, 232],
	[231, 232, 233],
	[233, 234, 235],
	[234, 235, 236],
	[236, 236, 238],
	[237, 238, 239],
	[239, 239, 240],
	[241, 241, 242],
	[242, 242, 243],
	[244, 244, 244],
	[245, 245, 246],
	[247, 247, 247],
	[248, 248, 249],
	[250, 250, 250],
	[251, 251, 252],
	[253, 253, 253],
	[254, 255, 254]
];

export let wind_seq = [
	[254, 252, 205],
	[254, 251, 202],
	[253, 250, 200],
	[252, 249, 198],
	[252, 247, 196],
	[251, 246, 194],
	[250, 245, 192],
	[250, 244, 190],
	[249, 243, 188],
	[248, 241, 185],
	[248, 240, 183],
	[247, 239, 181],
	[246, 238, 179],
	[246, 237, 177],
	[245, 236, 175],
	[244, 234, 173],
	[244, 233, 171],
	[243, 232, 168],
	[242, 231, 166],
	[242, 230, 164],
	[241, 229, 162],
	[240, 227, 160],
	[240, 226, 158],
	[239, 225, 156],
	[238, 224, 153],
	[238, 223, 151],
	[237, 222, 149],
	[236, 221, 147],
	[235, 220, 145],
	[235, 219, 143],
	[234, 217, 140],
	[233, 216, 138],
	[232, 215, 136],
	[232, 214, 134],
	[231, 213, 132],
	[230, 212, 129],
	[229, 211, 127],
	[229, 210, 125],
	[228, 209, 123],
	[227, 208, 121],
	[226, 207, 119],
	[225, 206, 116],
	[224, 205, 114],
	[223, 204, 112],
	[223, 203, 110],
	[222, 202, 108],
	[221, 201, 106],
	[220, 200, 103],
	[219, 199, 101],
	[218, 198, 99],
	[217, 197, 97],
	[216, 196, 95],
	[215, 196, 93],
	[214, 195, 91],
	[213, 194, 88],
	[212, 193, 86],
	[211, 192, 84],
	[209, 191, 82],
	[208, 190, 80],
	[207, 190, 78],
	[206, 189, 76],
	[205, 188, 74],
	[203, 187, 72],
	[202, 186, 70],
	[201, 186, 68],
	[200, 185, 66],
	[198, 184, 64],
	[197, 183, 62],
	[195, 183, 60],
	[194, 182, 59],
	[193, 181, 57],
	[191, 181, 55],
	[190, 180, 53],
	[188, 179, 51],
	[187, 179, 50],
	[185, 178, 48],
	[184, 177, 46],
	[182, 177, 44],
	[181, 176, 43],
	[179, 175, 41],
	[178, 175, 40],
	[176, 174, 38],
	[175, 173, 36],
	[173, 173, 35],
	[171, 172, 33],
	[170, 171, 32],
	[168, 171, 30],
	[167, 170, 29],
	[165, 170, 28],
	[163, 169, 26],
	[162, 168, 25],
	[160, 168, 23],
	[158, 167, 22],
	[157, 167, 21],
	[155, 166, 20],
	[153, 165, 18],
	[151, 165, 17],
	[150, 164, 16],
	[148, 164, 15],
	[146, 163, 14],
	[145, 162, 13],
	[143, 162, 12],
	[141, 161, 11],
	[139, 161, 10],
	[138, 160, 9],
	[136, 159, 8],
	[134, 159, 7],
	[132, 158, 7],
	[131, 158, 6],
	[129, 157, 6],
	[127, 156, 6],
	[125, 156, 5],
	[124, 155, 5],
	[122, 155, 5],
	[120, 154, 5],
	[118, 153, 5],
	[116, 153, 5],
	[115, 152, 5],
	[113, 151, 6],
	[111, 151, 6],
	[109, 150, 7],
	[107, 150, 7],
	[106, 149, 8],
	[104, 148, 8],
	[102, 148, 9],
	[100, 147, 9],
	[98, 146, 10],
	[97, 146, 11],
	[95, 145, 12],
	[93, 145, 12],
	[91, 144, 13],
	[89, 143, 14],
	[87, 143, 15],
	[86, 142, 16],
	[84, 141, 16],
	[82, 141, 17],
	[80, 140, 18],
	[78, 139, 19],
	[76, 139, 20],
	[75, 138, 20],
	[73, 137, 21],
	[71, 137, 22],
	[69, 136, 23],
	[67, 135, 23],
	[66, 134, 24],
	[64, 134, 25],
	[62, 133, 26],
	[60, 132, 26],
	[59, 131, 27],
	[57, 131, 28],
	[55, 130, 28],
	[53, 129, 29],
	[52, 129, 30],
	[50, 128, 30],
	[48, 127, 31],
	[46, 126, 32],
	[45, 125, 32],
	[43, 125, 33],
	[42, 124, 33],
	[40, 123, 34],
	[38, 122, 35],
	[37, 121, 35],
	[35, 121, 36],
	[34, 120, 36],
	[32, 119, 37],
	[31, 118, 37],
	[29, 117, 38],
	[28, 117, 38],
	[26, 116, 39],
	[25, 115, 39],
	[24, 114, 39],
	[22, 113, 40],
	[21, 112, 40],
	[20, 111, 40],
	[19, 111, 41],
	[18, 110, 41],
	[17, 109, 41],
	[16, 108, 42],
	[15, 107, 42],
	[14, 106, 42],
	[13, 105, 43],
	[13, 104, 43],
	[12, 103, 43],
	[12, 103, 43],
	[11, 102, 43],
	[11, 101, 44],
	[11, 100, 44],
	[10, 99, 44],
	[10, 98, 44],
	[10, 97, 44],
	[10, 96, 44],
	[11, 95, 44],
	[11, 94, 44],
	[11, 93, 44],
	[11, 92, 44],
	[12, 92, 44],
	[12, 91, 44],
	[12, 90, 44],
	[13, 89, 44],
	[13, 88, 44],
	[14, 87, 44],
	[14, 86, 44],
	[15, 85, 44],
	[15, 84, 44],
	[15, 83, 44],
	[16, 82, 43],
	[16, 81, 43],
	[17, 80, 43],
	[17, 79, 43],
	[18, 78, 43],
	[18, 77, 42],
	[19, 76, 42],
	[19, 75, 42],
	[20, 74, 42],
	[20, 74, 41],
	[20, 73, 41],
	[21, 72, 41],
	[21, 71, 40],
	[21, 70, 40],
	[22, 69, 40],
	[22, 68, 39],
	[22, 67, 39],
	[23, 66, 39],
	[23, 65, 38],
	[23, 64, 38],
	[23, 63, 37],
	[24, 62, 37],
	[24, 61, 36],
	[24, 60, 36],
	[24, 59, 35],
	[24, 58, 35],
	[24, 57, 34],
	[25, 56, 34],
	[25, 55, 33],
	[25, 54, 33],
	[25, 53, 32],
	[25, 52, 31],
	[25, 52, 31],
	[25, 51, 30],
	[25, 50, 30],
	[25, 49, 29],
	[25, 48, 28],
	[25, 47, 28],
	[25, 46, 27],
	[25, 45, 26],
	[24, 44, 26],
	[24, 43, 25],
	[24, 42, 24],
	[24, 41, 24],
	[24, 40, 23],
	[24, 39, 22],
	[23, 38, 21],
	[23, 37, 21],
	[23, 36, 20],
	[23, 35, 19],
	[23, 35, 18]
];

export let slev_seq = [
	[254, 254, 254],
	[254, 254, 253],
	[253, 253, 251],
	[253, 253, 250],
	[253, 253, 248],
	[253, 253, 247],
	[253, 252, 245],
	[252, 252, 244],
	[252, 252, 242],
	[252, 251, 241],
	[251, 251, 239],
	[251, 251, 238],
	[251, 250, 236],
	[250, 250, 234],
	[250, 250, 233],
	[250, 249, 231],
	[249, 249, 230],
	[249, 249, 228],
	[248, 248, 227],
	[248, 248, 225],
	[247, 247, 223],
	[247, 247, 222],
	[246, 246, 220],
	[246, 246, 218],
	[245, 245, 217],
	[244, 245, 215],
	[244, 244, 213],
	[243, 243, 211],
	[242, 243, 210],
	[241, 242, 208],
	[240, 241, 206],
	[239, 241, 204],
	[239, 240, 203],
	[238, 239, 201],
	[236, 238, 199],
	[235, 237, 197],
	[234, 236, 195],
	[233, 235, 193],
	[232, 234, 191],
	[231, 233, 190],
	[229, 232, 188],
	[228, 231, 186],
	[226, 230, 184],
	[225, 229, 182],
	[223, 228, 180],
	[222, 226, 178],
	[220, 225, 176],
	[219, 224, 174],
	[217, 222, 173],
	[215, 221, 171],
	[213, 220, 169],
	[212, 218, 167],
	[210, 217, 165],
	[208, 215, 164],
	[206, 214, 162],
	[204, 212, 160],
	[202, 211, 159],
	[200, 209, 157],
	[198, 208, 156],
	[197, 206, 154],
	[195, 205, 153],
	[193, 203, 151],
	[191, 202, 150],
	[189, 200, 149],
	[187, 199, 147],
	[185, 197, 146],
	[183, 196, 145],
	[181, 194, 144],
	[179, 193, 143],
	[178, 192, 142],
	[176, 190, 142],
	[174, 189, 141],
	[172, 187, 140],
	[171, 186, 139],
	[169, 185, 139],
	[167, 184, 138],
	[166, 182, 138],
	[164, 181, 137],
	[162, 180, 137],
	[161, 179, 136],
	[159, 178, 136],
	[158, 176, 136],
	[156, 175, 135],
	[155, 174, 135],
	[154, 173, 135],
	[152, 172, 135],
	[151, 171, 135],
	[150, 170, 135],
	[148, 169, 135],
	[147, 168, 135],
	[146, 167, 135],
	[144, 166, 135],
	[143, 166, 135],
	[142, 165, 135],
	[141, 164, 135],
	[140, 163, 135],
	[139, 162, 136],
	[137, 161, 136],
	[136, 161, 136],
	[135, 160, 136],
	[134, 159, 136],
	[133, 158, 137],
	[132, 158, 137],
	[131, 157, 137],
	[130, 156, 137],
	[129, 155, 138],
	[128, 155, 138],
	[127, 154, 138],
	[126, 153, 139],
	[125, 153, 139],
	[124, 152, 139],
	[123, 151, 140],
	[122, 151, 140],
	[121, 150, 141],
	[120, 149, 141],
	[119, 149, 141],
	[118, 148, 142],
	[117, 147, 142],
	[116, 147, 143],
	[115, 146, 143],
	[114, 146, 143],
	[113, 145, 144],
	[112, 144, 144],
	[111, 144, 145],
	[110, 143, 145],
	[109, 142, 145],
	[108, 142, 146],
	[108, 141, 146],
	[107, 141, 147],
	[106, 140, 147],
	[105, 139, 147],
	[104, 139, 148],
	[103, 138, 148],
	[102, 138, 149],
	[101, 137, 149],
	[100, 136, 149],
	[99, 136, 150],
	[98, 135, 150],
	[97, 135, 150],
	[96, 134, 151],
	[95, 133, 151],
	[94, 133, 152],
	[94, 132, 152],
	[93, 131, 152],
	[92, 131, 153],
	[91, 130, 153],
	[90, 129, 153],
	[89, 129, 153],
	[88, 128, 154],
	[87, 127, 154],
	[86, 127, 154],
	[85, 126, 155],
	[84, 125, 155],
	[83, 125, 155],
	[82, 124, 155],
	[81, 123, 155],
	[80, 122, 156],
	[79, 122, 156],
	[78, 121, 156],
	[77, 120, 156],
	[76, 119, 156],
	[75, 119, 156],
	[74, 118, 156],
	[74, 117, 157],
	[73, 116, 157],
	[72, 115, 157],
	[71, 115, 157],
	[70, 114, 157],
	[69, 113, 157],
	[68, 112, 157],
	[67, 111, 157],
	[66, 110, 156],
	[65, 109, 156],
	[64, 108, 156],
	[63, 107, 156],
	[62, 107, 156],
	[61, 106, 156],
	[60, 105, 155],
	[59, 104, 155],
	[58, 103, 155],
	[57, 102, 155],
	[56, 101, 154],
	[55, 100, 154],
	[54, 98, 154],
	[53, 97, 153],
	[52, 96, 153],
	[51, 95, 152],
	[50, 94, 152],
	[49, 93, 151],
	[48, 92, 151],
	[47, 91, 150],
	[47, 90, 150],
	[46, 89, 149],
	[45, 87, 148],
	[44, 86, 148],
	[43, 85, 147],
	[42, 84, 146],
	[41, 83, 145],
	[40, 81, 145],
	[39, 80, 144],
	[38, 79, 143],
	[37, 78, 142],
	[37, 76, 141],
	[36, 75, 140],
	[35, 74, 139],
	[34, 73, 139],
	[33, 71, 138],
	[32, 70, 137],
	[31, 69, 136],
	[31, 68, 135],
	[30, 66, 133],
	[29, 65, 132],
	[28, 64, 131],
	[27, 62, 130],
	[27, 61, 129],
	[26, 60, 128],
	[25, 58, 127],
	[24, 57, 126],
	[24, 56, 124],
	[23, 54, 123],
	[22, 53, 122],
	[21, 52, 121],
	[21, 50, 119],
	[20, 49, 118],
	[19, 48, 117],
	[18, 46, 116],
	[18, 45, 114],
	[17, 44, 113],
	[16, 43, 112],
	[15, 41, 110],
	[15, 40, 109],
	[14, 39, 108],
	[13, 37, 106],
	[12, 36, 105],
	[12, 35, 103],
	[11, 33, 102],
	[10, 32, 101],
	[9, 31, 99],
	[8, 29, 98],
	[8, 28, 97],
	[7, 27, 95],
	[6, 25, 94],
	[6, 24, 92],
	[5, 23, 91],
	[4, 21, 89],
	[4, 20, 88],
	[3, 19, 87],
	[2, 17, 85],
	[2, 16, 84],
	[1, 14, 82],
	[1, 13, 81],
	[0, 12, 80],
	[0, 10, 78],
	[0, 8, 77],
	[0, 6, 75],
	[0, 5, 74]
];

export let gray_seq = [
	[0, 0, 0],
	[1, 1, 1],
	[2, 2, 2],
	[3, 3, 3],
	[4, 4, 4],
	[5, 5, 5],
	[6, 6, 6],
	[7, 7, 7],
	[8, 8, 8],
	[9, 9, 9],
	[10, 10, 10],
	[11, 11, 11],
	[12, 12, 12],
	[13, 13, 13],
	[14, 14, 14],
	[15, 15, 15],
	[16, 16, 16],
	[17, 17, 17],
	[18, 18, 18],
	[19, 19, 19],
	[20, 20, 20],
	[21, 21, 21],
	[22, 22, 22],
	[23, 23, 23],
	[24, 24, 24],
	[25, 25, 25],
	[26, 26, 26],
	[27, 27, 27],
	[28, 28, 28],
	[29, 29, 29],
	[30, 30, 30],
	[31, 31, 31],
	[32, 32, 32],
	[33, 33, 33],
	[34, 34, 34],
	[35, 35, 35],
	[36, 36, 36],
	[37, 37, 37],
	[38, 38, 38],
	[39, 39, 39],
	[40, 40, 40],
	[41, 41, 41],
	[42, 42, 42],
	[43, 43, 43],
	[44, 44, 44],
	[45, 45, 45],
	[46, 46, 46],
	[47, 47, 47],
	[48, 48, 48],
	[49, 49, 49],
	[50, 50, 50],
	[51, 51, 51],
	[52, 52, 52],
	[53, 53, 53],
	[54, 54, 54],
	[55, 55, 55],
	[56, 56, 56],
	[57, 57, 57],
	[58, 58, 58],
	[59, 59, 59],
	[60, 60, 60],
	[61, 61, 61],
	[62, 62, 62],
	[63, 63, 63],
	[64, 64, 64],
	[65, 65, 65],
	[66, 66, 66],
	[67, 67, 67],
	[68, 68, 68],
	[69, 69, 69],
	[70, 70, 70],
	[71, 71, 71],
	[72, 72, 72],
	[73, 73, 73],
	[74, 74, 74],
	[75, 75, 75],
	[76, 76, 76],
	[77, 77, 77],
	[78, 78, 78],
	[79, 79, 79],
	[80, 80, 80],
	[81, 81, 81],
	[82, 82, 82],
	[83, 83, 83],
	[84, 84, 84],
	[85, 85, 85],
	[86, 86, 86],
	[87, 87, 87],
	[88, 88, 88],
	[89, 89, 89],
	[90, 90, 90],
	[91, 91, 91],
	[92, 92, 92],
	[93, 93, 93],
	[94, 94, 94],
	[95, 95, 95],
	[96, 96, 96],
	[97, 97, 97],
	[98, 98, 98],
	[99, 99, 99],
	[100, 100, 100],
	[101, 101, 101],
	[102, 102, 102],
	[103, 103, 103],
	[104, 104, 104],
	[105, 105, 105],
	[106, 106, 106],
	[107, 107, 107],
	[108, 108, 108],
	[109, 109, 109],
	[110, 110, 110],
	[111, 111, 111],
	[112, 112, 112],
	[113, 113, 113],
	[114, 114, 114],
	[115, 115, 115],
	[116, 116, 116],
	[117, 117, 117],
	[118, 118, 118],
	[119, 119, 119],
	[120, 120, 120],
	[121, 121, 121],
	[122, 122, 122],
	[123, 123, 123],
	[124, 124, 124],
	[125, 125, 125],
	[126, 126, 126],
	[127, 127, 127],
	[128, 128, 128],
	[129, 129, 129],
	[130, 130, 130],
	[131, 131, 131],
	[132, 132, 132],
	[133, 133, 133],
	[134, 134, 134],
	[135, 135, 135],
	[136, 136, 136],
	[137, 137, 137],
	[138, 138, 138],
	[139, 139, 139],
	[140, 140, 140],
	[141, 141, 141],
	[142, 142, 142],
	[143, 143, 143],
	[144, 144, 144],
	[145, 145, 145],
	[146, 146, 146],
	[147, 147, 147],
	[148, 148, 148],
	[149, 149, 149],
	[150, 150, 150],
	[151, 151, 151],
	[152, 152, 152],
	[153, 153, 153],
	[154, 154, 154],
	[155, 155, 155],
	[156, 156, 156],
	[157, 157, 157],
	[158, 158, 158],
	[159, 159, 159],
	[160, 160, 160],
	[161, 161, 161],
	[162, 162, 162],
	[163, 163, 163],
	[164, 164, 164],
	[165, 165, 165],
	[166, 166, 166],
	[167, 167, 167],
	[168, 168, 168],
	[169, 169, 169],
	[170, 170, 170],
	[171, 171, 171],
	[172, 172, 172],
	[173, 173, 173],
	[174, 174, 174],
	[175, 175, 175],
	[176, 176, 176],
	[177, 177, 177],
	[178, 178, 178],
	[179, 179, 179],
	[180, 180, 180],
	[181, 181, 181],
	[182, 182, 182],
	[183, 183, 183],
	[184, 184, 184],
	[185, 185, 185],
	[186, 186, 186],
	[187, 187, 187],
	[188, 188, 188],
	[189, 189, 189],
	[190, 190, 190],
	[191, 191, 191],
	[192, 192, 192],
	[193, 193, 193],
	[194, 194, 194],
	[195, 195, 195],
	[196, 196, 196],
	[197, 197, 197],
	[198, 198, 198],
	[199, 199, 199],
	[200, 200, 200],
	[201, 201, 201],
	[202, 202, 202],
	[203, 203, 203],
	[204, 204, 204],
	[205, 205, 205],
	[206, 206, 206],
	[207, 207, 207],
	[208, 208, 208],
	[209, 209, 209],
	[210, 210, 210],
	[211, 211, 211],
	[212, 212, 212],
	[213, 213, 213],
	[214, 214, 214],
	[215, 215, 215],
	[216, 216, 216],
	[217, 217, 217],
	[218, 218, 218],
	[219, 219, 219],
	[220, 220, 220],
	[221, 221, 221],
	[222, 222, 222],
	[223, 223, 223],
	[224, 224, 224],
	[225, 225, 225],
	[226, 226, 226],
	[227, 227, 227],
	[228, 228, 228],
	[229, 229, 229],
	[230, 230, 230],
	[231, 231, 231],
	[232, 232, 232],
	[233, 233, 233],
	[234, 234, 234],
	[235, 235, 235],
	[236, 236, 236],
	[237, 237, 237],
	[238, 238, 238],
	[239, 239, 239],
	[240, 240, 240],
	[241, 241, 241],
	[242, 242, 242],
	[243, 243, 243],
	[244, 244, 244],
	[245, 245, 245],
	[246, 246, 246],
	[247, 247, 247],
	[248, 248, 248],
	[249, 249, 249],
	[250, 250, 250],
	[251, 251, 251],
	[252, 252, 252],
	[253, 253, 253],
	[254, 254, 254],
	[255, 255, 255]
];
